{
	"dialog.ok": "確定",
	"dialog.cancel": "取消",
	"dialog.confirm": "確認",
	"dialog.close": "關閉",
	"dialog.import": "匯入",
	"dialog.save": "儲存",
	"dialog.discard": "撤回",
	"dialog.dontshowagain": "不再顯示",
	"data.cube": "方塊",
	"data.group": "群組",
	"data.texture": "紋理",
	"data.plugin": "插件",
	"data.preview": "預覽",
	"data.toolbar": "工具列",
	"data.image": "圖片",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "空白鍵",
	"keys.leftclick": "滑鼠左鍵",
	"keys.middleclick": "滑鼠中鍵",
	"keys.rightclick": "滑鼠右鍵",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "Fn %0",
	"keys.numpad": "數字鍵 %0",
	"keys.caps": "大小寫鎖定",
	"keys.menu": "Contextmenu",
	"keys.left": "Left",
	"keys.up": "Up",
	"keys.right": "Right",
	"keys.down": "Down",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "+",
	"keys.comma": ",鍵",
	"keys.point": ".鍵",
	"keys.minus": "-鍵",
	"keys.cross": "Cross鍵",
	"keys.end": "End",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "旋轉限制",
	"message.rotation_limit.message": "Minecraft 限制模型只能沿著一個軸旋轉，繞其他軸旋轉會清除所有其他軸的旋轉設定。如果您出於其他目的建模，則需要自由旋轉，請將模型轉換為「一般模型」。",
	"message.file_not_found.title": "找不到檔案",
	"message.file_not_found.message": "Blockbench 找不到指定的檔案，請確認是儲存在本機而非雲端。",
	"message.screenshot.title": "截圖",
	"message.screenshot.clipboard": "剪貼簿",
	"message.screenshot.right_click": "右鍵或長按擷取畫面複製",
	"message.invalid_file.title": "無效的檔案",
	"message.invalid_file.message": "無法開啟 json 檔案：%0",
	"message.invalid_model.title": "無效的模型檔案",
	"message.invalid_model.message": "這個檔案中沒有任何有效的模型數據。",
	"message.child_model_only.title": "空的子模型",
	"message.child_model_only.message": "這是 %0 的子模型，不包含任何模型。",
	"message.unsaved_textures.title": "紋理未儲存",
	"message.unsaved_textures.message": "你的模型含有未儲存的紋理，請確認有將其放置到正確的資源包資料夾中。",
	"message.model_clipping.title": "模型過大",
	"message.model_clipping.message": "您的模型包含 %0 個大於 Minecraft 允許的方塊尺寸限制的立方體，故此模型無法在 Minecraft 中運作。",
	"message.loose_texture.title": "匯入紋理",
	"message.loose_texture.message": "匯入的紋理不在資源包中，Minecraft 僅能從載入的資源包中載入紋理。",
	"message.loose_texture.change": "更改路徑",
	"message.update_res.title": "紋理解析度",
	"message.update_res.message": "是否要將專案的解析度更改為紋理的解析度？如果紋理的解析度比正常的要高，按下「取消」。",
	"message.update_res.update": "更新",
	"message.bedrock_overwrite_error.message": "Blockbench 無法將這個模型與舊的檔案合併。",
	"message.bedrock_overwrite_error.backup_overwrite": "建立備份並覆蓋",
	"message.bedrock_overwrite_error.overwrite": "覆蓋",
	"message.close_warning.message": "要儲存模型嗎？",
	"message.close_warning.web": "目前的工作將會遺失，確認要退出嗎？",
	"message.default_textures.title": "預設紋理",
	"message.default_textures.message": "選取預設資源包的 textures 資料夾",
	"message.default_textures.detail": "從 Minecraf 的 jar 檔案取出或自行 Google 下載。找到裡面的 textures 資料夾並開啟。Blockbench 會記住位置，並嘗試從裡面尋找紋理。",
	"message.default_textures.select": "選取預設的 textures 資料夾",
	"message.image_editor.title": "選取圖片編輯器",
	"message.image_editor.file": "選取檔案...",
	"message.image_editor.exe": "選取圖片編輯器程式",
	"message.display_skin.title": "Minecraft 外觀",
	"message.display_skin.message": "從電腦中選取外觀檔案，或輸入玩家名字",
	"message.display_skin.upload": "上傳外觀",
	"message.display_skin.reset": "重置",
	"message.invalid_plugin": "無效的插件，開啟控制台查看錯誤訊息",
	"message.load_plugin_app": "是否允許這個插件修改你的電腦？請確保只從信任的作者載入插件。",
	"message.load_plugin_web": "是否載入這個插件？請確保只從信任的作者載入插件。",
	"message.preset_no_info": "預設集並無此欄位的訊息",
	"message.restart_to_update": "重新啟動 Blockbench 以套用變更。",
	"message.save_file": "儲存為 %0",
	"dialog.project.title": "專案",
	"dialog.project.name": "檔案名稱",
	"dialog.project.parent": "父模型",
	"dialog.project.geoname": "模型識別符",
	"dialog.project.ao": "環境光遮蔽",
	"dialog.texture.title": "紋理",
	"dialog.texture.variable": "變數",
	"dialog.texture.namespace": "命名空間",
	"dialog.texture.folder": "資料夾",
	"dialog.extrude.title": "拉伸圖片",
	"dialog.extrude.mode": "掃描模式",
	"dialog.extrude.mode.areas": "區域",
	"dialog.extrude.mode.lines": "線條",
	"dialog.extrude.mode.columns": "柱",
	"dialog.extrude.mode.pixels": "像素",
	"dialog.extrude.opacity": "最低透明度",
	"dialog.extrude.scan": "掃瞄並匯入",
	"dialog.display_preset.title": "新建預設集",
	"dialog.display_preset.message": "選取要儲存的欄位",
	"dialog.display_preset.create": "建立",
	"dialog.select.title": "選取",
	"dialog.select.group": "在群組中選取",
	"dialog.select.name": "含有名稱",
	"dialog.select.random": "隨機 (%)",
	"dialog.select.select": "選取",
	"dialog.scale.title": "縮放模型",
	"dialog.scale.axis": "軸",
	"dialog.scale.clipping": "模型裁切：君之模巨也，溢於作區矣。",
	"dialog.scale.confirm": "比例",
	"dialog.plugins.title": "插件",
	"dialog.plugins.installed": "已安裝",
	"dialog.plugins.available": "可用",
	"dialog.plugins.install": "安裝",
	"dialog.plugins.uninstall": "解除安裝",
	"dialog.plugins.reload": "重新載入",
	"dialog.plugins.none_installed": "無安裝任何插件",
	"dialog.plugins.none_available": "無插件可用",
	"dialog.plugins.web_only": "僅限網頁應用程式可以使用",
	"dialog.plugins.app_only": "僅限桌面應用程式可以使用",
	"dialog.plugins.author": "作者：%0",
	"dialog.create_texture.folder": "資料夾",
	"dialog.create_texture.resolution": "解析度",
	"dialog.input.title": "輸入",
	"dialog.settings.settings": "設定",
	"dialog.settings.keybinds": "快捷鍵",
	"dialog.settings.about": "關於",
	"layout.color.back": "返回",
	"layout.color.back.desc": "背景與輸入框",
	"layout.color.dark": "黑暗",
	"layout.color.dark.desc": "畫布背景",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "主介面顏色",
	"layout.color.bright_ui": "亮色 UI",
	"layout.color.bright_ui.desc": "選單與工具提示",
	"layout.color.button": "按鈕",
	"layout.color.button.desc": "按鈕和切換開關",
	"layout.color.selected": "已選取",
	"layout.color.selected.desc": "選取的頁籤和物件",
	"layout.color.border": "邊框",
	"layout.color.border.desc": "按鈕與輸入框的邊框",
	"layout.color.accent": "強調色",
	"layout.color.accent.desc": "滑塊和其他",
	"layout.color.grid": "網格",
	"layout.color.grid.desc": "3D 預覽網格",
	"layout.color.text": "文字",
	"layout.color.text.desc": "通常文字",
	"layout.color.light": "淺色",
	"layout.color.light.desc": "語法凸顯",
	"layout.color.accent_text": "凸顯文字",
	"layout.color.accent_text.desc": "亮色文字或突顯的元素",
	"layout.font.main": "主要字型",
	"layout.font.headline": "標題字型",
	"about.version": "版本：",
	"settings.category.general": "一般",
	"settings.category.preview": "預覽",
	"settings.category.grid": "網格",
	"settings.category.edit": "編輯",
	"settings.category.snapping": "捕捉",
	"settings.category.defaults": "預設",
	"settings.category.dialogs": "對話框",
	"settings.category.export": "匯出",
	"settings.language": "語言",
	"settings.language.desc": "重新啟動 Blockbench 以套用變更。",
	"settings.backup_interval": "備份間隔",
	"settings.backup_interval.desc": "自動備份的分鐘間隔",
	"settings.origin_size": "樞紐點標示器",
	"settings.origin_size.desc": "樞紐點標示器的大小",
	"settings.control_size": "變形精靈大小",
	"settings.control_size.desc": "變形精靈的大小",
	"settings.display_skin": "Minecraft玩家外觀",
	"settings.display_skin.desc": "用於展示玩家模型的外觀",
	"settings.shading": "著色器",
	"settings.shading.desc": "在預覽中使用著色器",
	"settings.base_grid": "小型網格",
	"settings.base_grid.desc": "顯示較小的網格與軸線",
	"settings.large_grid": "方塊網格",
	"settings.large_grid.desc": "顯示 16×16 方塊的網格",
	"settings.full_grid": "精確方塊網格",
	"settings.full_grid.desc": "顯示精確的像素方塊網格",
	"settings.large_box": "尺寸限制盒",
	"settings.large_box.desc": "顯示大小限制的邊界",
	"settings.display_grid": "展示模式網格",
	"settings.display_grid.desc": "在展示模式中顯示網格",
	"settings.undo_limit": "復原上限",
	"settings.undo_limit.desc": "復原次數的上限",
	"settings.local_move": "以相對軸移動",
	"settings.local_move.desc": "移動元素時以自身的軸移動。",
	"settings.canvas_unselect": "按一下以取消選取背景",
	"settings.canvas_unselect.desc": "按一下畫布背景，取消選取所有元素。",
	"settings.paint_side_restrict": "筆刷限制模式",
	"settings.paint_side_restrict.desc": "限制筆刷只能在目前的表面塗畫。",
	"settings.autouv": "自動 UV",
	"settings.autouv.desc": "預設啟用自動 UV",
	"settings.create_rename": "重新命名新元素",
	"settings.create_rename.desc": "新建元素或群組時自動切換到命名欄位。",
	"settings.edit_size": "網格解析度",
	"settings.edit_size.desc": "元素對齊的網格解析度",
	"settings.shift_size": "Shift 解析度",
	"settings.shift_size.desc": "按著 Shift 時的網格解析度",
	"settings.ctrl_size": "Control 解析度",
	"settings.ctrl_size.desc": "按著 Control 時的網格解析度",
	"settings.negative_size": "負尺寸",
	"settings.negative_size.desc": "允許調整尺寸工具使用負值",
	"settings.minifiedout": "最小化匯出",
	"settings.minifiedout.desc": "將 JSON 輸出簡化成一行",
	"settings.export_groups": "匯出方塊或物品之群組",
	"settings.export_groups.desc": "將群組儲存至方塊或物品檔案",
	"settings.credit": "版權訊息",
	"settings.credit.desc": "在輸出的檔案中加入版權訊息",
	"settings.default_path": "預設 Minecraft 紋理路徑",
	"settings.default_path.desc": "Blokbench 載入預設紋理的路徑",
	"settings.image_editor": "圖片編輯器",
	"settings.image_editor.desc": "預設的圖片編輯器",
	"category.navigate": "導覽",
	"category.tools": "工具",
	"category.file": "檔案",
	"category.blockbench": "Blockbench",
	"category.edit": "編輯",
	"category.transform": "變形",
	"category.view": "檢視",
	"category.display": "顯示設定",
	"category.textures": "紋理",
	"category.misc": "其他",
	"keybind.preview_select": "選取",
	"keybind.preview_rotate": "旋轉視角",
	"keybind.preview_drag": "拖動視角",
	"keybind.confirm": "確認",
	"keybind.cancel": "取消",
	"action.slider_inflate": "膨脹",
	"action.slider_inflate.desc": "膨脹立方體，不影響 UV。",
	"action.slider_brush_size": "尺寸",
	"action.slider_brush_size.desc": "筆刷的尺寸（像素）",
	"action.slider_brush_opacity": "透明度",
	"action.slider_brush_opacity.desc": "筆刷透明度（0~255）",
	"action.slider_brush_softness": "硬度",
	"action.slider_brush_softness.desc": "筆刷硬度（%）",
	"action.uv_slider_pos_x": "水平移動",
	"action.uv_slider_pos_x.desc": "水平移動選中立方體的 UV",
	"action.uv_slider_pos_y": "垂直移動",
	"action.uv_slider_pos_y.desc": "垂直移動選中立方體的 UV",
	"action.uv_slider_size_x": "水平縮放",
	"action.uv_slider_size_x.desc": "水平縮放選中立方體的 UV",
	"action.uv_slider_size_y": "垂直縮放",
	"action.uv_slider_size_y.desc": "垂直移動選中立方體的 UV",
	"action.vertex_snap_mode": "捕捉模式",
	"action.vertex_snap_mode.desc": "頂點捕捉模式時只移動元素或調整大小",
	"action.move_tool": "移動",
	"action.move_tool.desc": "選取並移動元素的工具",
	"action.resize_tool": "調整尺寸",
	"action.resize_tool.desc": "選取和調整尺寸的工具",
	"action.brush_tool": "繪畫筆刷",
	"action.brush_tool.desc": "可在表面或UV編輯器作畫的工具",
	"action.vertex_snap_tool": "頂點捕捉",
	"action.vertex_snap_tool.desc": "將立方體間以頂點連起來",
	"action.swap_tools": "交換工具",
	"action.swap_tools.desc": "在移動和調整尺寸工具切換",
	"action.project_window": "專案…",
	"action.project_window.desc": "開啟專案視窗，可編輯模型的詳細資訊。",
	"action.open_model": "開啟模型",
	"action.open_model.desc": "從電腦上開啟模型",
	"action.extrude_texture": "拉伸紋理",
	"action.extrude_texture.desc": "拉伸紋理並新建模型",
	"action.export_blockmodel": "匯出方塊／物品模型",
	"action.export_blockmodel.desc": "匯出 Minecraft Java 版方塊／物品模型",
	"action.export_optifine_part": "匯出 OptiFine Part",
	"action.export_optifine_part.desc": "匯出 OptiFine 實體模型的單一個 part",
	"action.export_optifine_full": "匯出 OptiFine JEM",
	"action.export_optifine_full.desc": "匯出完整的 OptiFine 實體模型",
	"action.export_obj": "匯出 OBJ 模型",
	"action.export_obj.desc": "匯出成 Wavefront OBJ 格式，用於渲染",
	"action.settings_window": "設定 …",
	"action.settings_window.desc": "開啟 Blockbennch 設定對話框",
	"action.plugins_window": "插件…",
	"action.plugins_window.desc": "開啟插件商店視窗",
	"action.reset_layout": "重設版面配置",
	"action.reset_layout.desc": "將版面配置重設至 Blockbench 預設樣式",
	"action.load_plugin": "載入插件檔案",
	"action.load_plugin.desc": "匯入插件檔案",
	"action.reload_plugins": "重新載入插件",
	"action.reload_plugins.desc": "重新載入所有的開發用插件",
	"action.undo": "復原",
	"action.undo.desc": "復原上一次變更",
	"action.redo": "取消復原",
	"action.redo.desc": "取消復原上一次變更",
	"action.copy": "複製",
	"action.copy.desc": "複製選取區，面或顯示設定",
	"action.paste": "貼上",
	"action.paste.desc": "貼上選取區，面或顯示設定",
	"action.cut": "剪下",
	"action.cut.desc": "剪下選取區，面或顯示設定",
	"action.add_cube": "添加塊",
	"action.add_cube.desc": "添加一個新的塊",
	"action.add_group": "添加分組",
	"action.add_group.desc": "添加一個新的分組或骨骼",
	"action.outliner_toggle": "切換顯示更多選項",
	"action.outliner_toggle.desc": "在大綱視圖中顯示更多選項",
	"action.duplicate": "複製",
	"action.delete": "刪除",
	"action.sort_outliner": "大綱排序",
	"action.sort_outliner.desc": "按字母排序大綱",
	"action.select_window": "選取…",
	"action.select_window.desc": "按屬性搜尋和選取元素",
	"action.invert_selection": "反轉選取",
	"action.invert_selection.desc": "反轉選取選中的元素",
	"action.select_all": "全部選取",
	"action.collapse_groups": "解散群組",
	"action.collapse_groups.desc": "在大綱視圖中解散群組",
	"action.scale": "縮放…",
	"action.scale.desc": "縮放選取的立方體",
	"action.toggle_visibility": "切換顯示",
	"action.toggle_visibility.desc": "顯示或隱藏選取的元素",
	"action.toggle_export": "切換匯出",
	"action.toggle_export.desc": "切換選取元素的匯出設定",
	"action.toggle_autouv": "切換自動 UV",
	"action.toggle_autouv.desc": "選取的立方體是否自動 UV",
	"action.toggle_shade": "切換著色",
	"action.toggle_shade.desc": "選取的立方體是否要使用著色器",
	"action.rename": "重新命名",
	"action.rename.desc": "重新命名選取元素或群組的名稱",
	"action.add_display_preset": "新建預設",
	"action.add_display_preset.desc": "添加新的顯示設置預設",
	"action.fullscreen": "全螢幕",
	"action.fullscreen.desc": "切換全螢幕模式",
	"action.zoom_in": "放大",
	"action.zoom_in.desc": "放大介面",
	"action.zoom_out": "縮小",
	"action.zoom_out.desc": "縮小介面",
	"action.zoom_reset": "重設放大",
	"action.zoom_reset.desc": "將縮放比重設為 100 ％",
	"action.reset_interface": "重設介面",
	"action.reset_interface.desc": "重設 GUI 的位置和大小",
	"action.screenshot_model": "模型擷取畫面",
	"action.screenshot_model.desc": "從目前角度給模型擷取畫面",
	"action.screenshot_app": "應用程式截圖",
	"action.screenshot_app.desc": "截圖整個應用程式",
	"action.import_texture": "匯入紋理",
	"action.import_texture.desc": "從電腦中匯入紋理",
	"action.create_texture": "新增紋理",
	"action.create_texture.desc": "新建範本或空白紋理",
	"action.save_textures": "儲存紋理",
	"action.save_textures.desc": "儲存所有未儲存的紋理",
	"action.animated_textures": "播放動態紋理",
	"action.animated_textures.desc": "播放和暫停動畫紋理的預覽",
	"action.origin_to_geometry": "樞紐點對齊中心",
	"action.origin_to_geometry.desc": "樞紐點對齊至選取區中心",
	"action.bone_reset_toggle": "重設骨骼",
	"action.bone_reset_toggle.desc": "停止顯示父模型骨骼的立方體",
	"action.reload": "重新載入 Blockbench",
	"action.reload.desc": "重新載入 Blockbench，終止所有未儲存的程式。",
	"menu.file": "檔案",
	"menu.edit": "編輯",
	"menu.transform": "變形",
	"menu.display": "顯示",
	"menu.view": "檢視",
	"menu.file.new": "新建",
	"menu.file.recent": "最近",
	"menu.file.import": "匯入",
	"menu.file.export": "匯出",
	"menu.transform.rotate": "旋轉",
	"menu.transform.flip": "翻轉",
	"menu.transform.center": "對準中心",
	"menu.transform.properties": "屬性",
	"menu.display.preset": "套用預設集",
	"menu.display.preset_all": "全部套用預設集",
	"menu.display.remove_preset": "移除預設集",
	"menu.view.zoom": "縮放",
	"menu.view.background": "背景",
	"menu.view.screenshot": "截圖",
	"menu.cube.color": "標示器顏色",
	"menu.cube.texture": "紋理",
	"menu.cube.texture.transparent": "透明",
	"menu.cube.texture.blank": "空白",
	"menu.group.sort": "排序",
	"menu.texture.face": "套用至面",
	"menu.texture.file": "檔案",
	"menu.texture.refresh": "重新載入",
	"menu.texture.change": "更改檔案",
	"menu.texture.folder": "在資料夾中開啟",
	"menu.texture.edit": "編輯",
	"menu.texture.export": "儲存為",
	"menu.texture.save": "儲存",
	"menu.texture.properties": "屬性…",
	"menu.preview.background": "背景",
	"menu.preview.background.load": "載入",
	"menu.preview.background.position": "位置",
	"menu.preview.background.lock": "鎖定相機",
	"menu.preview.screenshot": "截圖",
	"menu.preview.perspective": "角度",
	"menu.preview.perspective.normal": "普通",
	"menu.preview.quadview": "四重分割檢視",
	"menu.preview.stop_drag": "停止背景移動",
	"menu.uv.mapping.rotation": "旋轉",
	"menu.uv.texture": "紋理",
	"cube.color.light_blue": "淺藍色",
	"cube.color.yellow": "黃色",
	"cube.color.orange": "橙色",
	"cube.color.red": "紅色",
	"cube.color.purple": "紫色",
	"cube.color.blue": "藍色",
	"cube.color.green": "綠色",
	"cube.color.lime": "淺綠色",
	"switches.visibility": "切換顯示",
	"switches.export": "匯出",
	"switches.autouv": "自動 UV",
	"panel.uv": "UV",
	"panel.display": "顯示",
	"panel.textures": "紋理",
	"panel.outliner": "大綱",
	"uv_editor.title": "UV 編輯器",
	"uv_editor.all_faces": "全部",
	"uv_editor.no_faces": "無",
	"face.north": "北",
	"face.south": "南",
	"face.west": "西",
	"face.east": "東",
	"face.up": "上",
	"face.down": "下",
	"direction.north": "北",
	"direction.south": "南",
	"direction.west": "西",
	"direction.east": "東",
	"direction.top": "頂部",
	"direction.bottom": "底部",
	"display.slot.third_right": "第三人稱右手",
	"display.slot.third_left": "第三人稱左手",
	"display.slot.first_right": "第一人稱右手",
	"display.slot.first_left": "第一人稱左手",
	"display.slot.head": "戴在頭上",
	"display.slot.ground": "掉落物",
	"display.slot.frame": "物品展示框",
	"display.slot.gui": "GUI",
	"display.rotation": "旋轉",
	"display.translation": "偏移",
	"display.scale": "縮放",
	"display.slot": "欄位",
	"display.reference": "參考模型",
	"display.reference.player": "玩家",
	"display.reference.zombie": "成年殭屍",
	"display.reference.armor_stand": "盔甲架",
	"display.reference.baby_zombie": "幼年殭屍",
	"display.reference.armor_stand_small": "小盔甲架",
	"display.reference.monitor": "普通",
	"display.reference.bow": "弓",
	"display.reference.block": "方塊",
	"display.reference.frame": "物品展示框",
	"display.reference.inventory_nine": "3×3",
	"display.reference.inventory_full": "背包",
	"display.reference.hud": "抬頭顯示器（HUD）",
	"display.preset.blank_name": "請輸入名稱",
	"display.preset.item": "預設物品",
	"display.preset.block": "預設方塊",
	"display.preset.handheld": "預設武器",
	"display.preset.rod": "預設棒子",
	"dialog.continue": "繼續",
	"message.square_textures": "紋理必須為正方形",
	"message.unsaved_texture.title": "未儲存的紋理",
	"message.unsaved_texture.message": "紋理未儲存的變更將會遺失，是否繼續？",
	"action.vertex_snap_mode.move": "移動",
	"action.vertex_snap_mode.scale": "縮放",
	"action.open_model_folder": "開啟模型資料夾",
	"action.open_model_folder.desc": "開啟模型資料夾",
	"action.change_textures_folder": "變更材質位置",
	"action.change_textures_folder.desc": "變更儲存材質的資料夾",
	"menu.texture.particle": "使用粒子",
	"message.update_notification.title": "無法安裝更新",
	"message.update_notification.message": "新版本已經釋出，請在設定中開啟自動更新進行安裝！",
	"message.untextured": "此平面沒有任何紋理",
	"dialog.toolbar_edit.title": "自訂工具列",
	"keybindings.reset": "重設",
	"keybindings.clear": "空白",
	"action.cube_counter": "立方體計數器",
	"action.uv_rotation": "UV 旋轉",
	"action.uv_rotation.desc": "UV 面的旋轉",
	"action.uv_grid": "UV 方格",
	"action.uv_grid.desc": "UV 選取器要捕捉的網格解析度",
	"action.uv_grid.auto": "自動",
	"action.uv_maximize": "UV 最大化",
	"action.uv_maximize.desc": "將此面的 UV 紋理最大化",
	"action.uv_auto": "自動 UV",
	"action.uv_auto.desc": "將此面的 UV 尺寸調整為實際面的大小",
	"action.uv_rel_auto": "相對自動 UV",
	"action.uv_rel_auto.desc": "讓此面的 UV 尺寸符合實際面的大小和位置",
	"action.uv_mirror_x": "UV X 鏡射",
	"action.uv_mirror_x.desc": "以 X 軸鏡射此面 UV",
	"action.uv_mirror_y": "UV Y 鏡射",
	"action.uv_mirror_y.desc": "以 Y 軸鏡射此面 UV",
	"action.uv_transparent": "移除面",
	"action.uv_transparent.desc": "移除目前的面",
	"action.uv_reset": "重設面",
	"action.uv_reset.desc": "重設目前的面",
	"action.cullface": "剔除面",
	"action.cullface.desc": "如果選取的模型覆蓋此面，則不渲染此面",
	"action.auto_cullface": "自動剔除面",
	"action.auto_cullface.desc": "將此面的剔除面設置為自身",
	"action.face_tint": "著色",
	"action.face_tint.desc": "開啟此面的著色選項",
	"menu.toolbar.edit": "自訂",
	"menu.toolbar.reset": "重設",
	"uv_editor.rotated": "旋轉",
	"uv_editor.auto_cull": "剔除自身",
	"uv_editor.copied": "複製的面",
	"uv_editor.pasted": "貼上的面",
	"uv_editor.copied_x": "已複製%0個面",
	"uv_editor.reset": "重設面",
	"uv_editor.maximized": "最大化",
	"uv_editor.autouv": "自動尺寸",
	"uv_editor.mirrored": "鏡射",
	"uv_editor.to_all": "套用至所有的面",
	"uv_editor.transparent": "轉為透明",
	"uv_editor.cullface_on": "開啟剔除面",
	"uv_editor.cullface_off": "關閉剔除面",
	"uv_editor.tint_on": "開啟著色",
	"uv_editor.tint_off": "關閉著色",
	"action.uv_apply_all": "套用至所有的面",
	"action.uv_apply_all.desc": "將目前面的設定套用至所有的面",
	"message.image_editor_missing.title": "預設圖片編輯器",
	"message.image_editor_missing.message": "選取圖片編輯器的應用程式",
	"message.image_editor_missing.detail": "Blockbench 在你的電腦上找不到任何圖片編輯器，請自行選取圖片編輯器應用程式。",
	"action.update_autouv": "更新自動 UV",
	"action.update_autouv.desc": "自動更新選取的立方體的 UV 映射",
	"category.uv": "UV",
	"status_bar.saved": "模型已儲存",
	"status_bar.unsaved": "有變更未儲存",
	"action.move_up": "往上移動",
	"action.move_up.desc": "將選取的立方體按攝影機視角往上移動",
	"action.move_down": "往下移動",
	"action.move_down.desc": "將選取的立方體按攝影機視角往下移動",
	"action.move_left": "往左移動",
	"action.move_left.desc": "將選取的立方體按攝影機視角往左移動",
	"action.move_right": "往右移動",
	"action.move_right.desc": "將選取的立方體按攝影機視角往右移動",
	"action.move_forth": "往前移動",
	"action.move_forth.desc": "將選取的立方體按攝影機視角往前移動",
	"action.move_back": "往後移動",
	"action.move_back.desc": "將選取的立方體按攝影機視角往後移動",
	"layout.color.wireframe": "線框",
	"layout.color.wireframe.desc": "線框視圖的線條",
	"action.add_animation": "添加動畫",
	"action.add_animation.desc": "創建一個空白動畫",
	"action.load_animation_file": "匯入動畫",
	"action.load_animation_file.desc": "匯入動畫檔按",
	"action.play_animation": "播放動畫",
	"action.play_animation.desc": "預覽選取的動畫",
	"action.slider_keyframe_time": "時間碼",
	"action.slider_keyframe_time.desc": "變更選取的關鍵影格的時間碼",
	"timeline.rotation": "旋轉",
	"timeline.position": "位置",
	"timeline.scale": "縮放",
	"menu.keyframe.quaternion": "四元數",
	"panel.animations": "動畫",
	"panel.keyframe": "關鍵影格",
	"panel.keyframe.type": "關鍵影格 （%0）",
	"generic.delete": "刪除",
	"generic.rename": "重新命名",
	"message.no_animation_selected": "請先選擇一個動畫",
	"message.no_bone_selected": "請先選擇一個骨骼",
	"message.duplicate_groups.title": "骨骼名稱重複",
	"message.duplicate_groups.message": "多個骨骼使用同樣的名稱，這會導致一些錯誤。",
	"action.delete_keyframes": "刪除關鍵影格",
	"action.delete_keyframes.desc": "刪除選取的關鍵影格",
	"menu.animation": "動畫",
	"menu.animation.loop": "迴圈模式",
	"menu.animation.override": "覆蓋",
	"menu.animation.anim_time_update": "動畫更新時間",
	"message.display_skin_model.title": "外觀模型",
	"message.display_skin_model.message": "選取外觀的模型樣式",
	"message.display_skin_model.classic": "經典",
	"message.display_skin_model.slim": "苗條",
	"message.bone_material": "更改骨骼的材質",
	"action.slider_animation_length": "動畫長度",
	"action.slider_animation_length.desc": "變更選取的動畫長度",
	"panel.variable_placeholders": "變數佔位符",
	"status_bar.vertex_distance": "距離：%0",
	"dialog.create_gif.title": "錄製 GIF",
	"dialog.create_gif.length": "長度",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "開始播放動畫",
	"category.animation": "動畫",
	"action.record_model_gif": "錄製 GIF...",
	"action.record_model_gif.desc": "從目前角度錄製模型動畫",
	"display.mirror": "鏡射",
	"data.separator": "分隔",
	"menu.preview.background.set_position": "設定位置",
	"dialog.toolbar_edit.hidden": "已隱藏",
	"action.export_class_entity": "匯出 Java 實體",
	"action.export_class_entity.desc": "將實體模型匯出為 Java 類別",
	"settings.seethrough_outline": "透視大綱",
	"settings.seethrough_outline.desc": "透視物件大綱",
	"mode.edit": "編輯",
	"mode.paint": "繪圖",
	"mode.display": "展示",
	"mode.animate": "動畫",
	"status_bar.recording_gif": "錄製 GIF",
	"status_bar.processing_gif": "處理 GIF中",
	"settings.backup_retain": "備份保留期限",
	"settings.backup_retain.desc": "設定 Blockbench 保留備份的天數",
	"action.rotate_tool": "旋轉",
	"action.rotate_tool.desc": "選取和旋轉元素的工具",
	"action.fill_tool": "油漆桶",
	"action.fill_tool.desc": "油漆桶可給整個面填滿單一顏色",
	"action.eraser": "橡皮擦",
	"action.eraser.desc": "橡皮擦工具可將紋理上的顏色變為透明",
	"action.color_picker": "取色器",
	"action.color_picker.desc": "從紋理像素上選取顏色",
	"switches.mirror": "鏡射 UV",
	"language_name": "正體中文（臺灣）",
	"message.plugin_reload": "重新載入 %0 個本機插件",
	"settings.brightness": "亮度",
	"settings.brightness.desc": "預覽的亮度，預設為 50",
	"menu.preview.perspective.reset": "重設相機",
	"action.fill_mode": "填滿模式",
	"action.fill_mode.face": "面",
	"action.fill_mode.color": "顏色",
	"action.toggle_mirror_uv": "鏡射 UV",
	"action.toggle_mirror_uv.desc": "切換選取立方體的 X 軸 UV 鏡射",
	"menu.texture.blank": "套用至無紋理的面",
	"dialog.scale.select_overflow": "選取溢位",
	"action.action_control": "動作控制",
	"action.action_control.desc": "搜索並且執行任何可用的操作",
	"keybindings.recording": "錄製快捷鍵",
	"keybindings.press": "使用快捷鍵來錄製快捷鍵鍵位。",
	"action.pivot_tool": "樞紐點工具",
	"action.pivot_tool.desc": "變更立方體和骨骼的樞紐點",
	"action.slider_animation_speed": "播放速度",
	"action.slider_animation_speed.desc": "時間軸的播放速度（%）",
	"action.previous_keyframe": "上一個關鍵影格",
	"action.previous_keyframe.desc": "跳至上一個關鍵影格",
	"action.next_keyframe": "下一個關鍵影格",
	"action.next_keyframe.desc": "跳至下一個關鍵影格",
	"message.outdated_client.title": "版本太舊",
	"message.outdated_client.message": "請更新至最新版 Blockbench 再繼續。",
	"action.export_asset_archive": "下載封存檔",
	"action.export_asset_archive.desc": "下載含有模型和紋理的封存檔。",
	"action.upload_sketchfab": "上傳至 Sketchab",
	"message.sketchfab.name_or_token": "請輸入 Sketchfab 名稱和 token",
	"dialog.sketchfab_uploader.title": "上傳 Sketchfab",
	"dialog.sketchfab_uploader.token": "API Token",
	"dialog.sketchfab_uploader.about_token": "這個 token 用於將 Blockbench 與你的 Sketchfab 帳戶連接，可在 %0 找到",
	"dialog.sketchfab_uploader.name": "模型名稱",
	"dialog.sketchfab_uploader.description": "說明",
	"dialog.sketchfab_uploader.tags": "標籤",
	"settings.sketchfab_token": "Sketchfab Token",
	"settings.sketchfab_token.desc": "這個 token 用於授權 Blockbench 上傳檔案到你的 Sketchfab 帳戶",
	"panel.color": "顏色",
	"data.origin": "樞紐點",
	"message.sketchfab.success": "模型上傳成功",
	"message.sketchfab.error": "上傳模型至 Sketchfab 失敗",
	"settings.outliner_colors": "大綱顏色",
	"settings.outliner_colors.desc": "元素和群組在大綱視圖中的顏色",
	"action.upload_sketchfab.desc": "上傳模型至 Sketchfab",
	"action.element_colors": "立方體顏色",
	"action.element_colors.desc": "大綱視圖中立方體的顏色",
	"texture.error.file": "找不到檔案",
	"texture.error.parent": "父模型提供的紋理",
	"message.recover_backup.title": "復原模型",
	"message.recover_backup.message": "Blockbench 意外關閉，你要復原未儲存的模型嗎？",
	"message.invalid_session.title": "無效的會話 token",
	"message.invalid_session.message": "欲加入的會話已過期或無效。",
	"dialog.create_texture.power": "2 次方大小",
	"dialog.create_gif.turn": "調整速度",
	"action.edit_session": "編輯會話…",
	"action.edit_session.desc": "連接至會話，與其他人一同編輯",
	"action.reset_keyframe": "同設關鍵影格",
	"action.reset_keyframe.desc": "重設選取的關鍵影格",
	"dialog.edit_session.title": "編輯會話",
	"edit_session.username": "使用者名稱",
	"edit_session.token": "Token",
	"edit_session.about": "編輯會話可用於網路模型協作，建立一個會話並發送給好友，對方就可以加入編輯。",
	"edit_session.join": "加入會話",
	"edit_session.create": "建立會話",
	"edit_session.quit": "退出會話",
	"edit_session.joined": "%0 加入了會話",
	"edit_session.left": "%0 離開了會話",
	"edit_session.quit_session": "離開目前的會話",
	"edit_session.status": "狀態",
	"edit_session.hosting": "主機",
	"edit_session.connected": "連接至會話",
	"dialog.sketchfab_uploader.private": "私人（Pro）",
	"dialog.sketchfab_uploader.password": "密碼（Pro）",
	"action.uv_select_all": "全部選取",
	"action.uv_select_all.desc": "選取 UV 對話框中的全部面",
	"panel.chat": "聊天",
	"edit_session.welcome": "歡迎來到%0的會話",
	"dialog.yes": "是",
	"dialog.no": "否",
	"generic.remove": "移除",
	"generic.download": "下載",
	"generic.search": "搜尋",
	"dates.today": "今天",
	"dates.yesterday": "昨天",
	"dates.this_week": "本週",
	"dates.weeks_ago": "%0 週前",
	"mode.start.new": "新建",
	"mode.start.recent": "最近",
	"format.free": "一般模型",
	"format.free.desc": "無任何限制的模型，適合遊戲引擎、渲染。",
	"format.java_block": "Java版方塊／物品",
	"format.java_block.desc": "Java版的方塊／物品模型。",
	"format.bedrock": "基岩版模型",
	"format.bedrock.desc": "Minecraft基岩版模型",
	"format.bedrock_old": "舊版基岩版模型",
	"format.bedrock_old.desc": "Minecraft基岩版 1.12 以前的實體模型",
	"format.modded_entity": "模組實體",
	"format.modded_entity.desc": "Minecraft 模組的實體模型，可匯出成 .java 類別檔案。",
	"format.optifine_entity": "OptiFine 實體",
	"format.optifine_entity.desc": "OptiFine 自訂實體模型",
	"keys.mouse": "滑鼠按鍵 %0",
	"message.cleared_blank_faces.title": "空白面",
	"message.cleared_blank_faces.message": "Blockbench 找到 %0 個沒有紋理的立方體，你是否要將這些元素移除？",
	"message.wireframe.enabled": "線框視圖已開啟",
	"message.wireframe.disabled": "線框視圖已關閉",
	"dialog.convert_project.title": "轉換專案",
	"dialog.create_texture.double_use": "保持多重紋理的透明度",
	"dialog.model_stats.title": "模型統計",
	"dialog.model_stats.cubes": "立方體",
	"dialog.model_stats.locators": "定位器",
	"dialog.model_stats.groups": "群組",
	"dialog.model_stats.vertices": "頂點",
	"dialog.model_stats.faces": "面面",
	"settings.username": "使用者名稱",
	"settings.username.desc": "編輯會話的使用者名稱",
	"settings.painting_grid": "繪圖網格",
	"settings.painting_grid.desc": "在繪圖模式的立方體紋理上顯示網格",
	"action.convert_project": "轉換專案",
	"action.convert_project.desc": "將目前的專案轉換為其他模型格式的專案",
	"action.close_project": "關閉專案",
	"action.close_project.desc": "關閉開啟的專案",
	"action.export_bedrock": "匯出基岩版幾何體",
	"action.export_bedrock.desc": "匯出成基岩版模型幾何體。",
	"action.save_project": "儲存專案",
	"action.save_project.desc": "將模型檔案儲存為專案檔。",
	"action.save_project_as": "另存專案為",
	"action.save_project_as.desc": "另存專案至其他位置",
	"action.export_over": "儲存模型",
	"action.export_over.desc": "儲存模型、紋理、動畫，覆蓋掉原有的檔案",
	"action.add_locator": "添加定位器",
	"action.add_locator.desc": "添加新的定位器，以控制粒子、牽引等位置",
	"action.uv_turn_mapping": "旋轉 UV 映射",
	"action.uv_turn_mapping.desc": "UV 映射旋轉 90 度",
	"action.remove_blank_faces": "移除空白的面",
	"action.remove_blank_faces.desc": "移除沒有紋理的面",
	"web.download_app": "下載 App",
	"uv_editor.turned": "旋轉映射",
	"display.reference.crossbow": "弩",
	"dialog.settings.search_results": "搜尋結果",
	"settings.animation_snap": "動畫捕捉",
	"settings.animation_snap.desc": "每秒動畫時間軸預設捕捉的關鍵影格",
	"action.import_optifine_part": "匯入 OptiFine Part",
	"action.import_optifine_part.desc": "匯入 Optifine Part 模型",
	"data.locator": "定位器",
	"mode.start.no_recents": "沒有最近開啟的模型",
	"panel.element": "元素",
	"panel.element.position": "位置",
	"panel.element.size": "大小",
	"panel.element.origin": "樞紐點",
	"panel.element.rotation": "旋轉",
	"message.canvas_limit_error.title": "畫布大小錯誤",
	"message.canvas_limit_error.message": "無法執行該操作，此格式限制畫布大小為 48，調整樞紐點來避免此一情況。",
	"data.effect": "效果",
	"generic.name": "名稱",
	"settings.recent_projects": "最近的模型數",
	"settings.recent_projects.desc": "記住的最近的模型數量",
	"settings.volume": "音量",
	"settings.volume.desc": "動畫中的音效控制",
	"action.clear_timeline": "清空時間軸",
	"action.clear_timeline.desc": "從時間軸中清除未選取的骨骼",
	"action.select_effect_animator": "動畫效果",
	"action.select_effect_animator.desc": "開啟時間軸加入音效和粒子效果",
	"action.timeline_focus": "過濾軌道",
	"action.timeline_focus.desc": "選取要在時間軸顯示的動畫軌道",
	"timeline.particle": "粒子",
	"timeline.sound": "音效",
	"timeline.effects": "效果",
	"data.format": "格式",
	"format.optifine_part": "OptiFine Part",
	"format.optifine_part.desc": "JPM OptiFine 實體模型",
	"action.reverse_keyframes": "倒轉關鍵影格",
	"action.reverse_keyframes.desc": "倒轉關鍵影格的順序",
	"generic.help": "協助",
	"message.removed_faces": "已移除 %0 個面",
	"dialog.sketchfab_uploader.draft": "草稿",
	"action.slider_pos": "移動 %0",
	"action.slider_pos.desc": "在 %0 軸移動立方體",
	"action.slider_size": "縮放 %0",
	"action.slider_size.desc": "在 %0 軸縮放立方體",
	"action.slider_rotation": "旋轉 %0",
	"action.slider_rotation.desc": "在 %0 軸旋轉立方體",
	"action.slider_origin": "樞紐點 %0",
	"action.slider_origin.desc": "移動樞紐點至 %0 軸",
	"action.rotate_cw": "旋轉 %0 +90°",
	"action.rotate_cw.desc": "選取的立方體 %0 軸旋轉 90°",
	"action.rotate_ccw": "旋轉 %0 -90°",
	"action.rotate_ccw.desc": "選取的立方體 %0 軸旋轉 -90°",
	"action.flip": "翻轉 %0",
	"action.flip.desc": "選取的立方體 %0 軸翻轉",
	"action.center": "對齊中心 %0",
	"action.center.desc": "選取的立方體 %0 軸對齊中心",
	"action.bring_up_all_animations": "顯示所有動畫",
	"panel.bone": "骨骼",
	"data.color": "顏色",
	"generic.export": "匯出",
	"generic.none": "無",
	"status_bar.recording": "錄製縮時影片",
	"message.add_to_palette": "加入至調色盤",
	"message.size_modifiers": "按著 Ctrl 或 Shift 進行更精細的縮放",
	"message.timelapse_start": "縮時影片錄製開始",
	"message.timelapse_stop": "縮時影片錄製停止",
	"message.import_palette.replace_palette": "載入舊調色盤",
	"message.import_palette.threshold": "合併臨界值",
	"dialog.timelapse.interval": "間隔（秒）",
	"dialog.timelapse.source": "來源",
	"dialog.timelapse.source.interface": "介面",
	"dialog.timelapse.source.locked": "鎖定角度",
	"dialog.timelapse.destination": "目標資料夾",
	"layout.color.checkerboard": "透明背景",
	"layout.color.checkerboard.desc": "畫布和 UV 編輯器的背景",
	"layout.font.code": "程式碼字型",
	"layout.css": "自訂 CSS",
	"settings.category.paint": "繪圖",
	"settings.deactivate_size_limit": "取消大小限制",
	"settings.deactivate_size_limit.desc": "取消模型格式的大小限制，這可能會倒置模型格式無效。",
	"settings.brush_opacity_modifier": "修改筆刷透明度",
	"settings.brush_opacity_modifier.desc": "使用觸控筆時變更筆刷透明度",
	"settings.brush_size_modifier": "筆刷大小",
	"settings.brush_size_modifier.desc": "使用觸控筆時變更筆刷大小",
	"settings.brush_modifier.pressure": "壓力",
	"settings.brush_modifier.tilt": "傾斜",
	"category.color": "顏色",
	"action.import_theme": "匯入主題",
	"action.export_theme": "匯出主題",
	"action.export_theme.desc": "以目前的設定建立主題檔案",
	"action.slider_color_h": "色調",
	"action.slider_color_s": "飽和度",
	"action.slider_color_v": "明度",
	"action.add_to_palette": "添加到調色板",
	"action.add_to_palette.desc": "將所選顔色添加到調色板",
	"action.import_palette": "匯入調色盤",
	"action.import_palette.desc": "匯入調色盤檔案",
	"action.export_palette": "匯出調色盤檔案",
	"action.export_palette.desc": "匯出 .gpl 調色盤檔案",
	"action.generate_palette": "生成調色盤",
	"action.generate_palette.desc": "從紋理生成調色盤",
	"action.sort_palette": "排列調色盤",
	"action.sort_palette.desc": "以顏色和亮度排列調色盤的顏色",
	"action.timelapse": "縮時…",
	"action.timelapse.desc": "錄製建模縮時攝影",
	"action.add_keyframe": "添加關鍵幀",
	"action.add_keyframe.desc": "添加關鍵幀到所選動畫",
	"action.bring_up_all_animations.desc": "顯示時間軸所有變更過的動畫",
	"timeline.timeline": "教學",
	"menu.palette.load.default": "預設預設",
	"generic.import": "匯入",
	"settings.brush_modifier.none": "無",
	"action.export_entity": "匯出為基岩版實體",
	"action.export_entity.desc": "將目前的實體加入到 mobs.json 檔案中",
	"settings.highlight_cubes": "凸顯立方體",
	"settings.highlight_cubes.desc": "選取或滑鼠移至立方體上方時凸顯立方體",
	"action.add_marker": "設置標記",
	"action.add_marker.desc": "設置一個時間軸點標記",
	"timeline.pre_effect_script": "腳本",
	"format.skin": "Minecraft外觀",
	"format.skin.desc": "編輯玩家和實體的外觀",
	"message.sketchfab.setup_guide": "想了解如何在 Sketchfab 上設置模型？請閱讀：%0",
	"dialog.skin.title": "新建 Minecraft 外觀",
	"dialog.skin.model": "模型",
	"action.toggle_skin_layer": "切換外觀外層",
	"action.toggle_skin_layer.desc": "是否顯示外觀的帽子和衣服",
	"action.gui_light": "GUI 光照",
	"action.gui_light.desc": "選取物品在背包中的光照方式",
	"action.gui_light.side": "側光照",
	"action.gui_light.front": "前光照",
	"action.move_keyframe_back": "關鍵畫格往後移",
	"action.move_keyframe_forth": "關鍵畫格往前移",
	"menu.help": "協助",
	"menu.help.discord": "Discord 伺服器",
	"menu.help.report_issue": "回報問題",
	"menu.help.plugin_documentation": "插件 API 文件",
	"menu.help.search_action": "搜尋和執行動作",
	"menu.help.donate": "贊助",
	"menu.help.about": "關於…",
	"menu.preview.background.clipboard": "從剪貼簿載入",
	"dialog.ignore": "忽略",
	"generic.unset": "未設定",
	"message.invalid_builtin_parent.title": "無效的父模型",
	"message.invalid_builtin_parent.message": "為匯出有效的模型，已取消連結無效的父模型%0。",
	"dialog.resize_texture.fill": "填滿",
	"dialog.resize_texture.fill.transparent": "透明",
	"dialog.resize_texture.fill.color": "顏色",
	"dialog.resize_texture.fill.repeat": "重複",
	"dialog.scale.element_pivot": "元素樞紐點",
	"dialog.scale.selection_center": "以選取部分為中心",
	"dialog.create_gif.length_mode": "長度模式",
	"dialog.create_gif.length_mode.seconds": "秒",
	"dialog.create_gif.length_mode.frames": "影格率",
	"dialog.create_gif.length_mode.animation": "動畫長度",
	"dialog.create_gif.length_mode.turntable": "調整旋轉",
	"dialog.save_angle.projection": "投影",
	"dialog.save_angle.projection.perspective": "透視投影",
	"dialog.save_angle.projection.orthographic": "正投影",
	"dialog.sketchfab_uploader.animations": "動畫動畫",
	"dialog.settings.theme": "主題",
	"settings.category.interface": "介面",
	"settings.preview_checkerboard": "預覽透明背景",
	"settings.preview_checkerboard.desc": "開關預覽透明背景",
	"settings.uv_checkerboard": "UV編輯器透明背景",
	"settings.uv_checkerboard.desc": "開關UV編輯器透明背景",
	"category.paint": "繪圖",
	"action.fill_mode.color_connected": "相鄰的顏色",
	"action.draw_shape_type": "形狀",
	"action.draw_shape_type.rectangle": "長方形",
	"action.draw_shape_type.rectangle_h": "長方形（空心）",
	"action.draw_shape_type.ellipse": "橢圓形",
	"action.draw_shape_type.ellipse_h": "橢圓形（空心）",
	"action.draw_shape_type.line": "直線",
	"action.mirror_painting": "鏡射繪圖",
	"action.mirror_painting.description": "在模型上繪畫時繪製對稱圖樣",
	"action.lock_alpha": "鎖定透明通道",
	"action.lock_alpha.description": "鎖定像素透明度",
	"action.draw_shape_tool": "繪製形狀",
	"action.draw_shape_tool.desc": "此工具用於在紋理上繪製簡單形狀",
	"action.export_gltf": "匯出為 glTF 模型",
	"action.export_gltf.desc": "將模型和動畫匯出為 glTF 模型，用於其他 3D 軟體",
	"action.transform_space": "變形空間",
	"action.transform_space.desc": "預設元素和骨骼的變形空間",
	"action.transform_space.global": "全域",
	"action.transform_space.local": "區域",
	"action.toggle_camera_projection": "開關攝影機投影",
	"action.toggle_camera_projection.desc": "在透視投影和正投影間切換",
	"action.load_camera_angle": "攝影機角度:%0",
	"action.load_camera_angle.desc": "載入攝影機「%0」度",
	"action.slider_face_tint": "色調索引",
	"action.slider_face_tint.desc": "設定此面的色調索引，-1 代表未設置。",
	"menu.help.quickstart": "快速開始精靈",
	"menu.help.developer": "開發人員",
	"menu.help.developer.dev_tools": "開啟開發人員工具",
	"menu.help.developer.reset_storage": "還原至出廠設定",
	"menu.help.developer.reset_storage.confirm": "是否要將 Blockbench 還原至出廠模式？所有自訂設定、快捷鍵、安裝的插件都會被刪除。",
	"menu.help.developer.cache_reload": "重新載入快取",
	"menu.preview.orthographic": "正投影",
	"menu.preview.save_angle": "儲存角度…",
	"menu.preview.angle": "角度",
	"menu.preview.angle.initial": "初始角度",
	"menu.preview.maximize": "最大畫最大畫",
	"uv_editor.copy_selection": "複製選取",
	"uv_editor.paste_selection": "貼上選取",
	"uv_editor.copy_paste_tool.place": "放置",
	"uv_editor.copy_paste_tool.mirror_x": "鏡射 X 軸",
	"uv_editor.copy_paste_tool.mirror_y": "鏡射 Y 軸",
	"uv_editor.copy_paste_tool.rotate": "旋轉 90 度",
	"dialog.project.modded_entity_version": "匯出版本",
	"dialog.save_angle.position": "攝影機位置",
	"dialog.save_angle.target": "焦點",
	"dialog.skin.pose": "姿勢",
	"layout.color.frame": "視窗外框",
	"layout.color.frame.desc": "視窗的外框和標題欄",
	"settings.large_grid_size": "方塊網格尺寸",
	"settings.large_grid_size.desc": "方塊網格的尺寸",
	"action.load_plugin_from_url": "從網址載入插件",
	"action.load_plugin_from_url.desc": "從指定的網址載入插件",
	"action.cube_counter.desc": "顯示目前的立方體數量和其他統計數字",
	"action.unlock_everything": "全部解鎖",
	"action.unlock_everything.desc": "解鎖大綱視圖中的所有群組和元素。",
	"action.load_palette": "載入調色盤",
	"action.load_palette.desc": "載入內建調色盤預設集",
	"action.toggle_locked": "切換鎖定",
	"action.toggle_locked.desc": "鎖定或解所選取的元素",
	"action.apply_display_preset": "應用預設",
	"action.apply_display_preset.desc": "應用默認或自定義顯示設置預設",
	"action.apply_display_preset.here": "應用于此槽位",
	"action.apply_display_preset.everywhere": "應用于所有槽位",
	"action.resolve_keyframe_expressions": "解析關鍵影格",
	"action.resolve_keyframe_expressions.desc": "解析關鍵影格的數學表達式",
	"action.fold_all_animations": "將所有動畫摺疊",
	"menu.palette.load.empty": "空白",
	"switches.lock": "鎖定",
	"settings.render_sides": "渲染的面",
	"settings.render_sides.desc": "選取要渲染的面",
	"settings.render_sides.auto": "自動",
	"settings.render_sides.front": "外部",
	"settings.render_sides.double": "內部和外部",
	"generic.enable": "啟用",
	"generic.disable": "停用",
	"generic.redacted": "已隱藏",
	"dialog.select_texture.import_all": "全部匯入",
	"dialog.skin.layer_template": "紋理圖層",
	"about.version.up_to_date": "已是最新",
	"about.version.update_available": "可用版本 %0",
	"settings.category.application": "應用程式",
	"settings.streamer_mode": "串流模式",
	"settings.streamer_mode.desc": "隱藏隱私內容，例如最近的模型",
	"settings.automatic_updates": "自動更新",
	"settings.automatic_updates.desc": "自動下載新版本，讓 Blockbench 保持在最新版本",
	"action.rotation_space": "旋轉空間",
	"action.focus_on_selection": "以選取為中心",
	"action.focus_on_selection.desc": "將攝影機對齊選取區的中心",
	"action.jump_to_timeline_start": "跳轉至動畫開始處",
	"action.jump_to_timeline_end": "跳轉至動畫結束處",
	"menu.help.updating": "更新中（%0 ％）",
	"menu.help.update_failed": "更新失敗",
	"menu.animation.loop.once": "只播放一次",
	"menu.animation.loop.hold": "停留在最後的關鍵影格",
	"menu.animation.loop.loop": "重複",
	"interface.streamer_mode_on": "串流模式已啟用",
	"generic.reset": "重置",
	"generic.restore": "回復",
	"keys.mousewheel": "滑鼠滾輪",
	"message.delete_animation.title": "刪除動畫",
	"message.delete_animation.message": "動畫已從 Blockbench 刪除，是否要將其從儲存的檔案中一起刪除？",
	"message.no_animation_to_import": "沒有要匯入的動畫",
	"dialog.material_instances.title": "材質實例",
	"dialog.animation_import.title": "選取要匯入的動畫",
	"dialog.create_texture.padding": "間距",
	"settings.fov": "視角廣度",
	"settings.fov.desc": "視角廣度，預設為 45",
	"settings.minify_bbmodel": "最小化專案檔",
	"settings.minify_bbmodel.desc": "將 .bbmodel 檔案儲存成一行程式碼",
	"action.edit_material_instances": "編輯材質實例",
	"action.edit_material_instances.desc": "編輯基岩版方塊幾何體的材質實例",
	"action.save_all_animations": "儲存全部動畫",
	"action.save_all_animations.desc": "儲存已載入的動畫",
	"action.keyframe_interpolation": "插值",
	"action.keyframe_interpolation.desc": "選取動畫插值方法",
	"action.keyframe_interpolation.linear": "直線",
	"action.keyframe_interpolation.catmullrom": "平滑",
	"action.timeline_focus.hide_empty": "隱藏空軌道",
	"menu.file.preferences": "偏好設定",
	"menu.animation.blend_weight": "混合權重",
	"menu.animation.save": "儲存",
	"menu.animation.properties": "屬性…",
	"menu.animation.file": "檔案",
	"menu.animation.snapping": "捕捉",
	"menu.animation.open_location": "開啟檔案位置",
	"panel.keyframe.add_data_point": "新增關鍵影格資料點",
	"panel.keyframe.remove_data_point": "移除關鍵影格資料點",
	"panel.keyframe.pre": "前",
	"panel.keyframe.post": "後",
	"generic.all": "全部",
	"message.small_face_dimensions.title": "不相容的面",
	"message.small_face_dimensions.message": "選取的部分包含小於 1 的面，Box UV 系統會將其視作0個像素，紋理可能會無法正常顯示。",
	"message.small_face_dimensions.face_uv": "這個模型格式支援使用 pre-face UV，可處理小於 1 的面的材質。點選檔案→專案，取消勾選 Box UV。",
	"dialog.plugins.outdated_client": "需要新版本的 Blockbench",
	"dialog.plugins.outdated_plugin": "該插件太舊，不適用於現在的 Blockbench",
	"settings.motion_trails": "運動軌跡",
	"settings.motion_trails.desc": "在動畫編輯器中顯示運動軌跡",
	"settings.antialiasing": "反鋸齒",
	"settings.antialiasing.desc": "開關預覽反鋸齒，重啟 Blockbench 以套用變更",
	"action.timeline_frame_back": "往後跳轉 1 個關鍵影格",
	"action.timeline_frame_forth": "往前跳轉 1 個關鍵影格",
	"panel.bone.ik": "反向運動（實驗性）",
	"settings.particle_tick_rate": "粒子遊戲刻",
	"settings.particle_tick_rate.desc": "每秒的粒子效果刻，預設為 30",
	"action.lock_motion_trail": "鎖定運動軌跡",
	"action.lock_motion_trail.desc": "鎖定選取群組的運動軌跡",
	"menu.animation_file.unload": "取消載入動畫檔案",
	"data.null_object": "空物件",
	"status_bar.toggle_sidebar": "開關側邊攔",
	"message.load_plugin_failed.title": "載入插件失敗",
	"message.load_plugin_failed.message": "請確認插件檔案名與 Plugin.register() 中所使用的ID「%0」相同。",
	"dialog.project.uv_mode": "UV 模式",
	"dialog.project.uv_mode.box_uv": "Box UV",
	"dialog.project.uv_mode.face_uv": "Per-face UV",
	"dialog.project.texture_size": "紋理尺寸",
	"dialog.animation_export.title": "選取要匯出的動畫",
	"dialog.create_texture.rearrange_uv": "重新排列 UV",
	"layout.color.subtle_text": "次要文字",
	"layout.color.subtle_text.desc": "對比度較低的第二文字",
	"settings.interface_scale": "介面縮放比例",
	"settings.interface_scale.desc": "Blockbench 介面的縮放比例",
	"settings.background_rendering": "背景渲染",
	"settings.background_rendering.desc": "滑鼠不在視窗時更新預覽畫面",
	"settings.ctrl_shift_size": "Control + Shift解析度",
	"settings.ctrl_shift_size.desc": "按下Control + Shift 的網格解析度",
	"settings.hardware_acceleration": "硬體加速",
	"settings.hardware_acceleration.desc": "將渲染任務分配給顯示卡，重啟Blockbench套用變更",
	"action.explode_skin_model": "展開外觀的模型",
	"action.explode_skin_model.desc": "開啟爆炸檢視模式以便編輯覆蓋的面",
	"action.export_minecraft_skin": "匯出 Minecraft 外觀",
	"action.export_minecraft_skin.desc": "將 Minecraft 外觀匯出為 .png 紋理",
	"action.add_null_object": "添加空目標",
	"action.add_null_object.desc": "添加新的空對象",
	"action.animated_texture_frame": "動態紋理幀",
	"action.animated_texture_frame.desc": "設置當前幀使用的動態紋理",
	"action.export_animation_file": "匯出動畫…",
	"action.export_animation_file.desc": "將選取的動畫匯出成一個檔案",
	"action.timeline_graph_editor": "開關圖像編輯器",
	"action.timeline_graph_editor.desc": "在時間軸切換圖像編輯器和關鍵影格編輯器",
	"menu.file.recent.clear": "清除最近的檔案",
	"switches.shade": "著色",
	"generic.share": "分享",
	"dates.minute": "%0 分鐘",
	"dates.minutes": "%0 分鐘",
	"dates.hour": "%0 小時",
	"dates.hours": "%0 小時",
	"dates.day": "%0 天",
	"dates.days": "%0 天",
	"dates.week": "%0 週",
	"dates.weeks": "%0 週",
	"dates.year": "%0 年",
	"dates.years": "%0 年",
	"message.installed_plugin": "已成功安裝 %0 插件",
	"message.installed_plugin_fail": "無法安裝 %0 插件",
	"dialog.share_model.title": "分享模型",
	"dialog.share_model.expire_time": "過期時間",
	"dialog.share_model.failed": "上傳模型失敗",
	"action.import_java_block_model": "加入 Java 版方塊／物品模型",
	"action.import_java_block_model.desc": "從 JSON 檔案匯入 Minecraft Java 版方塊／物品模型至目前的模型",
	"action.share_model": "分享…",
	"action.share_model.desc": "建立一個連結，分享你的模型",
	"action.import_project": "匯入專案",
	"action.import_project.desc": "從另一個 .bbmodel 檔案匯入至目前的專案",
	"dialog.toolbar_edit.hidden_tools": "有些工具可能會因目前的編輯模式、格式或其他情形而自動隱藏。",
	"settings.camera_near_plane": "攝影機接近平面",
	"settings.camera_near_plane.desc": "攝影機距離物件最小的渲染距離，值越大越能減少 Z-fighting 的問題，預設值為 1。",
	"mode.start.keymap_preference.desc": "如果這是你第一次使用 Blockbench，或者使用過其他 3D 軟體，你可以自訂快捷鍵來適應操作，稍後可從設定中變更。",
	"message.load_keymap": "是否要載入這個快捷鍵設定檔？這會覆蓋目前你的快捷鍵設定。",
	"message.keymap_loaded": "已載入快捷鍵設定檔",
	"dialog.convert_project.current_format": "目前的格式",
	"dialog.create_texture.rearrange_uv.desc": "新建重新排列過的 UV，讓每個面都能有紋理。",
	"dialog.create_texture.power.desc": "將紋理的尺寸鎖定為 2² 大小，例如 64 或 128。有些渲染器必須啟用此選項。",
	"dialog.create_texture.double_use.desc": "如果二個元素UV位置相同，在新的 UVmap 中維持原樣。",
	"dialog.create_texture.padding.desc": "在範本各個元素間加入邊距。",
	"dialog.create_texture.resolution.desc": "紋理的基本解析度，以像素為單位。實際的紋理 map 大小可能會因元素的數量和大小而不同。",
	"dialog.create_gif.color": "背景顏色",
	"dialog.save_angle.zoom": "縮放",
	"dialog.skin.variant": "變種",
	"dialog.flip_animation.info": "骨骼名稱中含有「left」和「right」會視為相反的骨骼。",
	"dialog.export_private_settings.title": "隱私設定",
	"dialog.export_private_settings.message": "你的檔案含有以下的私人資訊：**%0**，在與別人分享檔案前移除這些數值。",
	"dialog.export_private_settings.keep": "維持",
	"settings.timecode_frame_number": "將時間碼顯示為關鍵畫格數字",
	"settings.timecode_frame_number.desc": "在時間軸顯示關鍵畫格數字，而非厘秒",
	"settings.animation_sample_rate": "動畫取樣率",
	"settings.animation_sample_rate.desc": "使用該格式原生不支援的每秒取樣率",
	"keybind.preview_zoom": "放大",
	"action.gradient_tool": "漸層工具",
	"action.gradient_tool.desc": "在紋理上建立漸層",
	"action.import_settings": "匯入設定",
	"action.import_settings.desc": "匯入 .bbsettings 檔案",
	"action.export_settings": "匯出設定",
	"action.export_settings.desc": "將 Blockbench 的設定值匯出為 .bbesettings 檔案",
	"action.load_keymap": "載入快捷鍵設定檔",
	"action.load_keymap.default": "預設（觸控板/滑鼠）",
	"action.load_keymap.mouse": "預設（滑鼠）",
	"action.load_keymap.default.desc": "預設的 Blockbench 快捷鍵設定，筆電的觸控板用於移動檢視視角。",
	"action.load_keymap.mouse.desc": "預設的 Blockbench 快捷鍵設定，滑鼠中鍵用於移動檢視視角。",
	"action.load_keymap.blender.desc": "適用於 Blender 使用者的快捷鍵設定",
	"action.load_keymap.cinema4d.desc": "適用於 Cinema 4D 使用者的快捷鍵設定",
	"action.load_keymap.maya.desc": "適用於 Autodesk Maya 使用者的快捷鍵設定",
	"action.import_keymap": "匯入快捷鍵設定檔",
	"action.import_keymap.desc": "匯入 .bbkeymap 快捷鍵設定檔",
	"action.export_keymap": "匯出快捷鍵設定檔",
	"action.export_keymap.desc": "匯出快捷鍵設定檔為 .bbkeymap 檔案",
	"action.edit_history": "編輯紀錄",
	"action.edit_history.desc": "檢視復原和取消復原的編輯紀錄",
	"action.group_elements": "將元素集合成一個群組",
	"action.group_elements.desc": "將選取的元素集合成一個群組",
	"action.unfold_groups": "取消摺疊群組",
	"action.unfold_groups.desc": "取消摺疊大綱視圖中的所有群組",
	"action.edit_bedrock_binding": "編輯快捷鍵…",
	"action.edit_bedrock_binding.desc": "變更此幾何體綁定的骨骼",
	"action.pick_screen_color": "選取螢幕顏色",
	"action.pick_screen_color.desc": "從你的螢幕上選取顏色",
	"action.view_mode": "檢視模式",
	"action.view_mode.desc": "變更模型檢視模式",
	"action.view_mode.textured": "紋理",
	"action.view_mode.solid": "點線面",
	"action.view_mode.wireframe": "線框",
	"action.toggle_sidebars": "開關側邊欄",
	"action.toggle_sidebars.desc": "開啟或關閉側邊欄",
	"action.set_animation_end": "設定動畫終點",
	"action.set_animation_end.desc": "設定目前時間軸上的動畫終點",
	"action.flip_animation": "翻轉動畫",
	"action.flip_animation.desc": "複製選取的關鍵影格至模型另一側來翻轉動畫",
	"action.graph_editor_zero_line": "包含零線",
	"action.graph_editor_zero_line.desc": "是否要在圖像編輯器中顯示零線",
	"menu.texture.render_mode": "渲染模式",
	"menu.texture.render_mode.emissive": "發光",
	"menu.texture.render_mode.layered": "層疊",
	"menu.preview.angle.edit": "編輯角度…",
	"menu.animation.start_delay": "起始延時",
	"menu.animation.loop_delay": "重複延遲",
	"menu.animation.flip_keyframes": "翻轉關鍵影格",
	"menu.mobile_keyboard.disable_all": "全部停用",
	"panel.keyframe.toggle_uniform_scale": "開關均勻縮放",
	"camera_angle.common_isometric_right": "等軸距右側（2:1）",
	"camera_angle.common_isometric_left": "等軸距左側（2:1）",
	"camera_angle.true_isometric_right": "等軸距右側（30°）",
	"camera_angle.true_isometric_left": "等軸距左側（30°）",
	"menu.help.wiki": "Blockbench 維基",
	"settings.update_to_prereleases": "更新至預發布版",
	"settings.update_to_prereleases.desc": "自動更新 Blockbench 至預發布版以測試新功能。預發布版很不穩定，在進行重要工作時請勿開啟此選項。",
	"data.separator.spacer": "間隔",
	"data.separator.linebreak": "換行",
	"data.setting": "設定",
	"generic.select_all": "全部選取",
	"generic.select_none": "不選取",
	"projects.new_tab": "新分頁",
	"projects.close_tab": "關閉分頁",
	"message.invalid_format.title": "無效的格式",
	"message.invalid_format.message": "此模型為 %0 格式，Blockbench 無法開啟。您可能需要插件才能正常開啟。",
	"message.invalid_link": "無效或過期的連結",
	"message.default_textures.current": "目前的路徑",
	"message.update_after_restart": "重新啟動後將會安裝更新",
	"message.copy_paste_tool_viewport": "此工具僅能在 UV 面板使用",
	"dialog.project.shadow_size": "影子大小",
	"dialog.find_replace.target": "目標",
	"dialog.find_replace.target.element_names": "元素名稱",
	"dialog.find_replace.target.group_names": "群組名稱",
	"dialog.find_replace.target.animation_names": "動畫名稱",
	"dialog.find_replace.target.keyframe_values": "關鍵影格數值",
	"dialog.find_replace.find": "尋找",
	"dialog.find_replace.replace": "取代",
	"dialog.find_replace.regex": "正則表達式",
	"dialog.add_primitive.shape": "形狀",
	"dialog.add_primitive.shape.circle": "圓形",
	"dialog.add_primitive.shape.tube": "管狀",
	"dialog.add_primitive.shape.cone": "錐體",
	"dialog.add_primitive.shape.cylinder": "圓柱",
	"dialog.add_primitive.shape.sphere": "球",
	"dialog.add_primitive.shape.torus": "環狀",
	"dialog.add_primitive.shape.cube": "立方體",
	"dialog.add_primitive.shape.pyramid": "角錐",
	"dialog.add_primitive.diameter": "直徑",
	"dialog.add_primitive.height": "高度",
	"dialog.add_primitive.sides": "邊數",
	"dialog.add_primitive.minor_diameter": "厚度",
	"dialog.add_primitive.minor_sides": "最小邊數",
	"dialog.create_texture.combine_polys": "合併的面",
	"dialog.create_texture.combine_polys.desc": "將共面的面合併至同一個 UV",
	"dialog.model_stats.meshes": "網格",
	"dialog.export_private_settings.omit": "忽略",
	"layout.select": "選擇",
	"layout.options": "選項",
	"layout.color": "顏色樣式",
	"layout.documentation": "文檔",
	"layout.color.bright_ui_text": "淺色 UI",
	"layout.color.bright_ui_text.desc": "淺色背景的文字顏色",
	"layout.name": "名稱",
	"layout.author": "作者",
	"settings.dialog.desc": "顯示%0對話框",
	"settings.export_empty_groups": "匯出空白的群組",
	"settings.export_empty_groups.desc": "將空白的群組一同匯出",
	"category.separators": "分隔符號",
	"keybind.preview_area_select": "區域選擇",
	"action.color_erase_mode": "擦除模式",
	"action.color_erase_mode.desc": "開啟殺除模式之後，填滿和長方形工具會減去顏色。",
	"action.open_from_link": "從連結開啟模型…",
	"action.open_from_link.desc": "從 blckbn.ch 網址開啟模型",
	"action.import_obj": "匯入 OBJ 模型",
	"action.import_obj.desc": "從 OBJ 模型匯入網格物件",
	"action.add_plugin": "安裝插件",
	"action.add_plugin.desc": "通過動作控制安裝插件",
	"action.remove_plugin": "解除安裝插件",
	"action.remove_plugin.desc": "從動作控制解除安裝插件",
	"action.add_mesh": "添加網格",
	"action.add_mesh.desc": "添加一個新的網格形狀",
	"action.add_texture_mesh": "添加紋理網格",
	"action.add_texture_mesh.desc": "添加一個新的紋理網格",
	"action.find_replace": "尋找／取代…",
	"action.find_replace.desc": "尋找和取代部分名稱",
	"action.hide_everything_except_selection": "隱藏選取以外的部分",
	"action.hide_everything_except_selection.desc": "開關選取以外元素的可見度",
	"action.transform_space.normal": "正常",
	"action.selection_mode": "選取模式",
	"action.selection_mode.desc": "變更元素於檢視視圖中的選取模式",
	"action.selection_mode.object": "物件",
	"action.selection_mode.face": "面",
	"action.selection_mode.vertex": "頂點",
	"action.create_face": "新增面或線",
	"action.create_face.desc": "在選取的頂點之間建立面或線",
	"action.convert_to_mesh": "轉換成網格",
	"action.convert_to_mesh.desc": "將選取的元素轉換成網格",
	"action.invert_face": "翻轉面",
	"action.invert_face.desc": "翻轉選取的面，使其面向相反的方向",
	"action.extrude_mesh_selection": "拉伸選取",
	"action.extrude_mesh_selection.desc": "拉伸選取的網格",
	"action.loop_cut": "環形切割",
	"action.loop_cut.desc": "將選取的線段中使用環形切割分離網格",
	"action.merge_meshes": "合併網格",
	"action.merge_meshes.desc": "將多個網格合而為一",
	"action.keyframe_uniform": "統一縮放",
	"action.keyframe_uniform.desc": "在選取的關鍵影格啟用統一縮放",
	"menu.locator.ignore_inherited_scale": "忽略繼承的縮放",
	"menu.texture.elements": "套用變更至元素",
	"uv_editor.transparent_face": "透明的面",
	"display.pose_angle": "姿勢角度（僅用於預覽）",
	"data.mesh": "網格",
	"dialog.create_texture.type": "類型",
	"dialog.create_texture.type.blank": "空白",
	"dialog.create_texture.type.template": "紋理範本",
	"dialog.create_texture.type.color_map": "純色範本",
	"dialog.sketchfab_uploader.suggested_tags": "建議的標籤",
	"dialog.sketchfab_uploader.category": "分類",
	"dialog.sketchfab_uploader.category2": "分類2",
	"layout.restore_backup": "您的自訂 %0 主題遭到覆蓋。按這裡還原。",
	"layout.borders": "邊界",
	"action.fill_mode.element": "元素",
	"action.inset_mesh_selection": "插入選取",
	"action.inset_mesh_selection.desc": "插入選取的網格",
	"action.dissolve_edges": "邊緣溶解",
	"action.dissolve_edges.desc": "溶解網格中選取的邊，合併兩個面",
	"action.split_mesh": "切割網格",
	"action.split_mesh.desc": "將網格選取的面切割成新的網格",
	"action.merge_vertices": "合併頂點",
	"action.merge_vertices.desc": "將頂點合併至第一個選取的頂點",
	"action.view_mode.normal": "法線",
	"action.snap_uv_to_pixels": "將 UV 對齊像素",
	"action.snap_uv_to_pixels.desc": "將選取的 UV 頂點對齊像素網格",
	"menu.file.import.import_open_project": "匯入開啟的專案",
	"menu.help.unlock_projects": "解鎖全部專案",
	"status_bar.selection.faces": "%0 個面",
	"status_bar.selection.vertices": "%0 個頂點",
	"message.merged_vertices": "在 %1 處找到與合併了 %0 個頂點",
	"settings.vertex_merge_distance": "頂點合併距離",
	"settings.vertex_merge_distance.desc": "按距離合併頂點的距離",
	"settings.show_only_selected_uv": "僅顯示選取的 UV",
	"settings.show_only_selected_uv.desc": "UV 編輯器預設僅顯示選取的 UV",
	"action.merge_vertices.merge_all": "全部合併",
	"action.merge_vertices.merge_all_in_center": "全部合併至中央",
	"action.merge_vertices.merge_by_distance": "按距離合併",
	"action.merge_vertices.merge_by_distance_in_center": "按距離合併至中央",
	"action.uv_rotate_left": "UV 向左旋轉",
	"action.uv_rotate_left.desc": "選取的 UV 逆時針旋轉",
	"action.uv_rotate_right": "UV 向右旋轉",
	"action.uv_rotate_right.desc": "選取的 UV 順時針旋轉",
	"menu.uv.display_uv": "顯示 UV",
	"menu.uv.display_uv.selected_faces": "選取的面",
	"menu.uv.display_uv.selected_elements": "全部的面",
	"menu.uv.display_uv.all_elements": "全部元素上的面",
	"menu.paste.face": "UV 面",
	"menu.paste.mesh_selection": "選取網格",
	"menu.paste.outliner": "元素",
	"uv_editor.show_all_faces": "顯示所有面",
	"uv_editor.show_selected_faces": "顯示選取的面",
	"status_bar.selection.edges": "%0 個邊",
	"action.selection_mode.edge": "邊",
	"message.cannot_re_import.title": "模型無法重新匯入",
	"message.cannot_re_import.message": "匯出後的模型無法匯入至 Blockbench。請確保你是將模型儲存成專案檔。",
	"generic.default": "預設",
	"units.pixels_per_meter": "%0 像素每公尺",
	"mode.pose": "姿勢",
	"modifier_actions.resize_both_sides": "所有方向重新調整大小",
	"modifier_actions.resize_one_side": "單個方向調整大小",
	"modifier_actions.draw_line": "畫線",
	"modifier_actions.drag_without_snapping": "無對齊拖放",
	"modifier_actions.stretch_keyframes": "拉伸關鍵影格",
	"modifier_actions.resize_background": "調整背景大小",
	"modifier_actions.select_multiple": "多個選取",
	"modifier_actions.select_range": "選取範圍",
	"modifier_actions.drag_to_duplicate": "拖放拷貝",
	"modifier_actions.uniform_scaling": "統一縮放",
	"modifier_actions.snap_direction": "對齊方向",
	"message.no_valid_elements": "沒有選取有效的元素…",
	"dialog.add_primitive.shape.plane": "平面",
	"dialog.save_angle.rotation_mode": "旋轉模式",
	"dialog.save_angle.rotation": "旋轉",
	"dialog.save_angle.fov": "視角廣度",
	"settings.hide_tab_bar": "自動隱藏頁籤列",
	"settings.hide_tab_bar.desc": "僅有一個頁籤開啟時隱藏頁籤列",
	"settings.status_bar_modifier_keys": "在狀態欄顯示修飾鍵",
	"settings.status_bar_modifier_keys.desc": "在狀態欄顯示建議的修飾鍵",
	"settings.ground_plane": "地面平面",
	"settings.ground_plane.desc": "在模型下方顯示平面",
	"settings.preview_paste_behavior": "預設預覽貼上行為",
	"settings.preview_paste_behavior.desc": "選取在編輯模式預覽貼上時的行為，有多個選項可選",
	"settings.preview_paste_behavior.always_ask": "總是詢問",
	"action.new_window": "新視窗",
	"action.new_window.desc": "開啟新視窗",
	"action.export_collada": "匯出為 Collada Model (.dae)",
	"action.export_collada.desc": "將模型和動畫匯出為 .dae 檔，以在其他 3D 應用程式中使用",
	"action.paint_mode_uv_overlay": "UV 覆蓋",
	"action.paint_mode_uv_overlay.desc": "在繪圖模式中顯示UV覆蓋",
	"action.bake_animation_into_model": "烘焙動畫到模型",
	"action.bake_animation_into_model.desc": "將當前顯示的動畫幀複制到模型中。只應用旋轉和位置，忽略縮放。",
	"action.keyframe_interpolation.step": "步數",
	"action.set_ik_target": "設定逆運動學目標",
	"action.set_ik_target.desc": "選取要使用逆運動學空物件移動的目標骨骼",
	"menu.action_control.type.tab": "頁籤",
	"menu.action_control.type.angle": "攝影機角度",
	"menu.action_control.recent_in_streamer_mode": "確定嗎？已開啟串流模式",
	"menu.action_control.recent_in_streamer_mode.desc": "你確定要顯示最近的模型？",
	"menu.tools": "工具",
	"menu.file.recent.more": "檢視更多…",
	"menu.null_object.lock_ik_target_rotation": "鎖定逆運動學目標的旋轉",
	"menu.animation_file.import_remaining": "匯入剩餘的動畫",
	"edit.loop_cut.offset": "偏移",
	"edit.extrude_mesh_selection.extend": "延展",
	"cube.color.pink": "粉紅色",
	"cube.color.silver": "銀色",
	"dialog.plugins.offline": "沒有網路連線",
	"dialog.create_texture.pixel_density": "像素密度",
	"dialog.create_texture.pixel_density.desc": "每公分紋理的像素密度，材質貼圖的大小會因元素而有所不同。",
	"panel.skin_pose": "姿勢",
	"panel.skin_pose.none": "無",
	"panel.skin_pose.natural": "自然",
	"panel.skin_pose.walking": "走路",
	"panel.skin_pose.crouching": "蹲下",
	"panel.skin_pose.sitting": "坐著",
	"panel.skin_pose.jumping": "跳躍",
	"panel.skin_pose.aiming": "瞄準",
	"edit.loop_cut.direction": "方向",
	"data.texture_mesh": "紋理網格",
	"generic.left": "左",
	"generic.right": "右",
	"mode.start.quick_setup": "快速設置",
	"mode.start.keymap": "按鍵綁定",
	"mode.start.quick_setup.more_themes": "等…",
	"dialog.resize_texture.animation_frames": "動畫幀",
	"dialog.export_emission_map.title": "導出動畫",
	"dialog.export_emission_map.format": "格式",
	"dialog.export_emission_map.format.luminance": "亮度",
	"dialog.export_emission_map.format.luminance_inverted": "亮度反轉",
	"dialog.export_emission_map.format.colors": "顏色",
	"dialog.export_emission_map.threshold": "透明度阈值",
	"dialog.export_emission_map.round_up": "向上取舍%0到%1",
	"dialog.export_emission_map.flip_y": "翻轉Y軸",
	"dialog.select.type": "元素種類",
	"dialog.create_texture.max_edge_angle": "邊角阈值",
	"dialog.create_texture.max_edge_angle.desc": "兩個面之間仍將被組合的最大角度",
	"dialog.create_texture.max_island_angle": "島嶼的最大傾斜角度",
	"dialog.create_texture.max_island_angle.desc": "同一個 UV 貼圖可以組合的最大角度",
	"settings.mobile_panel_side": "行動裝置面板位置",
	"settings.mobile_panel_side.desc": "選擇橫向操作時面板的顯示方位",
	"settings.obj_face_export_mode": "OBJ 多邊形面匯出模式",
	"settings.obj_face_export_mode.desc": "選擇讓 OBJ 匯出程式將所有面轉換為三角形或四邊形",
	"settings.obj_face_export_mode.both": "預設",
	"settings.obj_face_export_mode.tris": "轉換為三角形",
	"settings.obj_face_export_mode.quads": "轉換為四邊形",
	"action.seam_tool": "縫隙連接工具",
	"action.seam_tool.desc": "用于定義網格邊緣上的 UV 接縫的工具",
	"action.resolve_group": "解析分組",
	"action.resolve_group.desc": "解析分組，同時將其子項保留在同一位置",
	"action.move_to_group": "移動到群組",
	"action.move_to_group.desc": "將所選元素移至其他大綱視圖組",
	"action.select_seam": "選擇 UV 接縫",
	"action.select_seam.desc": "為所選邊緣選擇 UV 接縫模式",
	"action.select_seam.auto": "自動",
	"action.select_seam.join": "加入",
	"action.select_seam.divide": "劃分",
	"action.adjust_brightness_contrast": "調整亮度和對比度...",
	"action.adjust_brightness_contrast.desc": "調整所選紋理的亮度和對比度",
	"action.adjust_saturation_hue": "調整飽和度和色調...",
	"action.adjust_saturation_hue.desc": "調整所選紋理的飽和度和色調",
	"action.invert_colors": "反轉顔色",
	"action.invert_colors.desc": "反轉所選紋理的所有顔色",
	"action.adjust_curves": "調整曲線...",
	"action.adjust_curves.desc": "調整所選紋理的亮度曲線",
	"action.flip_texture_x": "水平翻轉紋理",
	"action.flip_texture_y": "垂直翻轉紋理",
	"action.resize_texture": "調整紋理大小...",
	"action.view_mode.uv": "UV 預覽",
	"action.append_to_template": "向模板追加元素...",
	"action.append_to_template.desc": "將選中的元素添加到紋理模板",
	"action.move_texture_with_uv": "使用 UV 移動紋理",
	"action.move_texture_with_uv.desc": "拖動 UV 面時移動面的紋理",
	"action.timeline_setups": "時間線設置",
	"action.save_timeline_setup": "保存時間線設置...",
	"action.save_timeline_setup.desc": "保存當前選定的動畫師和頻道的預設",
	"menu.texture": "紋理",
	"menu.texture.render_mode.default": "預設",
	"menu.texture.merge_onto_texture": "向上合併貼圖",
	"menu.animation.unload": "釋放",
	"panel.timeline": "時間軸",
	"action.pan_tool": "平移工具",
	"action.pan_tool.desc": "在視口和紋理編輯器中導航的工具",
	"mode.start.recent.favorite": "標示為最愛",
	"mode.start.info": "資訊",
	"mode.start.target": "目標",
	"mode.start.start": "開始",
	"mode.start.create_new": "創建新模型",
	"mode.start.format.informations": "好消息 :",
	"mode.start.format.resources": "資源",
	"format.free.info.meshes": "此格式支援使用方塊以及自訂形狀的網格，可製作低多邊形風格的模型。",
	"format.free.info.limitation": "此模型無法直接用於 Minecraft 或其他需要特定格式的遊戲讀取。",
	"format.skin.info.skin": "此格式專為製作 Minecraft 皮膚與實體貼圖而設計。",
	"format.skin.info.model": "無法更改此模型。若要修改模型，請先透過 **File** > **Convert Project** 來轉換成其他格式。",
	"format.java_block.info.rotation": "每個元素一次只能沿著一個方向旋轉",
	"format.java_block.info.size": "此模型受限於 3x3x3 方塊的尺寸，若需調整物品模型的實際顯示大小，可至 **顯示設定** 進行設定。",
	"format.java_block.info.animation": "原版 Minecraft 不支援此格式的動畫。若是用於模組，建議使用 GeckoLib。否則你只能透過指令更換模型或利用動態紋理來達成動畫效果。",
	"format.bedrock.info.textures": "每個模型只能有一個紋理",
	"format.bedrock_block": "基岩版方塊",
	"format.bedrock_block.desc": "Bedrock版方塊模型",
	"format.modded_entity.info.integer_size": "每個方塊的尺寸必須是整數，無法添加小數點。",
	"format.modded_entity.info.format": "此模型是用 Java 程式碼編寫，而不是以 Blockbench 匯出格式使用專用資料結構。",
	"format.optifine_entity.info.optifine_required": "此模型需要安裝 OptiFine 才能正常顯示。",
	"format.optifine_entity.info.pivots": "軸心處於鎖定狀態，建議不要進行修改以避免錯誤。",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "其他",
	"format_category.loaders": "加載程序",
	"message.recover_backup.recover": "恢復",
	"message.invalid_characters.title": "路徑錯誤",
	"message.invalid_characters.message": "匯入的路徑路徑中含有不合規定字元、大寫字母或空格。限使用以下支援的字元：%0",
	"dialog.share_model.thumbnail": "縮略圖",
	"dialog.skin.high_res_texture": "請注意，具有所選分辨率的皮膚將無法作為常規 Minecraft 皮膚使用。 選擇較低的分辨率。",
	"settings.allow_display_slot_mirror": "啟用鏡像顯示功能",
	"settings.allow_display_slot_mirror.desc": "啟用 Java 物品模型的鏡像顯示功能。警告：此功能僅限在 Minecraft 1.14（含）以前的版本或特定條件下有效。",
	"action.switch_tabs": "切換選項卡",
	"action.switch_tabs.desc": "在打開的選項卡之間循環。 按住 shift 以反方向循環。",
	"action.unselect_all": "取消選取全部",
	"action.save_palette": "保存調色板...",
	"action.save_palette.desc": "將當前調色板保存在 Blockbench 中供以後使用",
	"action.keyframe_column_create": "創建關鍵幀列",
	"action.keyframe_column_create.desc": "如果它們已經具有關鍵幀，將時間軸中的所有通道按當前時間進行關鍵幀",
	"action.keyframe_column_select": "選擇關鍵幀列",
	"action.keyframe_column_select.desc": "沿播放鍵下方的列，選擇時間軸中的所有關鍵幀",
	"menu.uv": "UV",
	"menu.keyframe": "關鍵影格",
	"menu.palette.load.update": "更新表",
	"menu.palette.load.update.desc": "使用目前 Blockbench 調色板的顏色更新此調色板",
	"menu.timeline_marker.set_time": "設定時間",
	"uv_editor.scale_uv": "UV規模",
	"action.preview_scene": "預覽場景",
	"action.preview_scene.desc": "更改模型預覽場景",
	"preview_scene.minecraft_overworld": "主世界",
	"preview_scene.minecraft_nether": "地獄",
	"preview_scene.minecraft_end": "終界",
	"dialog.project.modded_entity_flip_y": "Y軸翻轉",
	"preview_scene.studio": "工作室",
	"format.image": "圖片",
	"modifier_actions.set_copy_source": "設定複製來源",
	"message.load_images.title": "載入圖片",
	"message.load_images.edit_image": "編輯圖片",
	"dialog.add_primitive.align_edges": "對齊邊緣",
	"dialog.flip_animation.show_in_timeline": "在時間軸中顯示修改後的骨骼",
	"settings.default_cube_size": "方塊尺寸",
	"settings.default_cube_size.desc": "建立新立方體時設定預設立方體大小",
	"settings.uniform_keyframe": "統一比例關鍵幀",
	"settings.uniform_keyframe.desc": "預設情況下，將縮放關鍵幀設定為統一縮放。",
	"settings.nearest_rectangle_select": "矩形選擇：最近邊緣",
	"settings.nearest_rectangle_select.desc": "將矩形選取範圍對齊到最近的像素邊緣，就像在 GIMP 中一樣，而不是對齊到整個像素。",
	"settings.pick_color_opacity": "選擇顏色不透明度",
	"settings.pick_color_opacity.desc": "使用顏色選擇器選擇顏色不透明度，並將其設為畫筆不透明度。",
	"settings.paint_with_stylus_only": "僅使用觸控筆作畫",
	"settings.paint_with_stylus_only.desc": "僅使用觸控筆進行繪畫，導航請保留滑鼠或觸控輸入。",
	"action.copy_brush_mode": "複制畫筆模式",
	"action.copy_brush_mode.copy": "拷貝",
	"action.copy_brush_mode.pattern": "圖案",
	"action.copy_brush_mode.sample": "樣本",
	"action.brush_shape": "畫筆形狀",
	"action.brush_shape.square": "方形",
	"action.brush_shape.circle": "圓圈",
	"action.blend_mode": "混合模式",
	"action.blend_mode.default": "默認",
	"action.blend_mode.set_opacity": "設定不透明度",
	"action.blend_mode.color": "顏色",
	"action.blend_mode.behind": "背面",
	"action.blend_mode.multiply": "相乘",
	"action.blend_mode.divide": "劃分",
	"action.blend_mode.add": "添加",
	"action.blend_mode.subtract": "相減",
	"action.blend_mode.screen": "屏幕",
	"action.blend_mode.overlay": "覆蓋",
	"action.blend_mode.hard_light": "強光",
	"action.blend_mode.difference": "差異",
	"action.copy_brush": "複制畫筆",
	"action.copy_brush.desc": "使用筆刷來複制紋理的一部分或繪制圖案。按住Ctrl並點擊以選擇複制源。",
	"action.validator_window": "查看模型問題...",
	"action.validator_window.desc": "打開驗證器，列出當前模型的問題。",
	"action.cancel_gif": "取消GIF",
	"menu.text_edit.copy_vector": "複製向量",
	"menu.brush_presets.dialog": "筆刷預設",
	"menu.brush_presets.pixel_brush": "像素筆",
	"menu.brush_presets.smooth_brush": "平滑筆刷",
	"menu.texture.edit_in_blockbench": "編輯於Blockbench",
	"menu.mirror_painting.axis": "Axis",
	"menu.mirror_painting.axis.desc": "Select on which axis paint strokes will get mirrored",
	"menu.mirror_painting.global": "Global Symmetry",
	"menu.mirror_painting.global.desc": "Enabled mirror painting on the model in global space",
	"menu.mirror_painting.local": "Local Symmetry",
	"menu.mirror_painting.local.desc": "Enable mirror painting in local space for each element",
	"menu.mirror_painting.texture_frames": "Repeat on Flipbook Frames",
	"menu.mirror_painting.texture_frames.desc": "Mirror paint strokes to every frame of animated textures",
	"format.bedrock_block.info.size_limit": "塊的總大小在所有維度上限制為 30 像素。 上線最多可以在所有方向上偏離塊中心 7 個像素。",
	"format.bedrock_block.info.textures": "在 Blockbench 中，可以將多種紋理應用于不同的立方體，但需要在行為包中進行額外的設置才能在遊戲中正常工作。",
	"format.image.desc": "Edit images in the 2D image editor",
	"generic.delete_all": "刪除全部",
	"message.child_model_only.open": "Open Parent Model",
	"dialog.project.credit": "制作信息",
	"dialog.convert_project.create_copy": "創建副本",
	"dialog.texture.frame_time": "幀時間",
	"dialog.texture.frame_time.desc": "設置每幀可見的時長，以刻度為單位。 每個刻度為 1/20 秒。",
	"dialog.texture.frame_interpolate": "插入",
	"dialog.texture.frame_interpolate.desc": "在下一個動畫幀之前插入淡入淡出",
	"dialog.texture.frame_order_type": "循環模式",
	"dialog.texture.frame_order_type.loop": "循環",
	"dialog.texture.frame_order_type.backwards": "反向循环",
	"dialog.texture.frame_order_type.back_and_forth": "往返循環",
	"dialog.texture.frame_order_type.custom": "自定義順序",
	"dialog.texture.frame_order": "幀順序",
	"dialog.texture.frame_order.desc": "設置自定義的幀順序。 第一幀開始%0。",
	"dialog.select.mode": "模式",
	"dialog.select.mode.new": "新選擇",
	"dialog.select.mode.add": "添加到已選擇",
	"dialog.select.mode.remove": "從已選擇移除",
	"dialog.select.mode.in_selection": "僅從已選擇內容中選擇",
	"dialog.predicate_overrides.model": "模型",
	"dialog.predicate_overrides.predicates": "謂詞",
	"dialog.predicate_overrides.variants": "變體",
	"dialog.predicate_overrides.start_value": "開始",
	"dialog.predicate_overrides.add_override": "添加覆寫",
	"dialog.predicate_overrides.add_predicate": "添加謂詞",
	"dialog.predicate_overrides.generate_overrides": "生成覆寫",
	"dialog.predicate_overrides.confirm_delete": "您確定要刪除所有覆寫嗎？",
	"dialog.predicate_overrides.predicate.angle": "指南針角度",
	"dialog.predicate_overrides.predicate.blocking": "已遮擋",
	"dialog.predicate_overrides.predicate.broken": "已損壞",
	"dialog.predicate_overrides.predicate.cast": "已施出",
	"dialog.predicate_overrides.predicate.cooldown": "冷卻中",
	"dialog.predicate_overrides.predicate.damage": "損壞",
	"dialog.predicate_overrides.predicate.damaged": "已損壞",
	"dialog.predicate_overrides.predicate.lefthanded": "左手",
	"dialog.predicate_overrides.predicate.pull": "拉伸值",
	"dialog.predicate_overrides.predicate.pulling": "正在拉伸",
	"dialog.predicate_overrides.predicate.charged": "已拉開",
	"dialog.predicate_overrides.predicate.firework": "有火箭",
	"dialog.predicate_overrides.predicate.throwing": "准備好投擲",
	"dialog.predicate_overrides.predicate.time": "當日時間",
	"dialog.predicate_overrides.predicate.custom_model_data": "自定義模型信息",
	"dialog.predicate_overrides.predicate.level": "光照強度",
	"dialog.predicate_overrides.predicate.filled": "收納袋裝滿程度",
	"dialog.predicate_overrides.predicate.tooting": "嘟嘟",
	"settings.model_export_scale": "Model Export Scale",
	"settings.model_export_scale.desc": "Factor by which the scale of exported glTF, DAE, and FBX models gets reduced. The default is 16, which converts 16 Blockbench units into 1 meter in the export.",
	"action.export_fbx": "導出 FBX 模型",
	"action.export_fbx.desc": "將模型和動畫導出為 FBX 文件以在其他 3D 應用程序和遊戲引擎中使用",
	"action.center_lateral": "中央橫向",
	"action.center_lateral.desc": "在 X 和 Z 軸上將所選元素居中",
	"action.adjust_opacity": "調整不透明度...",
	"action.adjust_opacity.desc": "調整所選紋理的不透明度",
	"action.rotate_texture_cw": "順時針旋轉紋理",
	"action.rotate_texture_ccw": "逆時針旋轉紋理",
	"action.predicate_overrides": "編輯謂詞覆寫...",
	"action.predicate_overrides.desc": "根據所選條件選擇模型以覆蓋原模型",
	"action.auto_set_cullfaces": "設置自動剔除面",
	"action.auto_set_cullfaces.desc": "當面被相鄰塊覆蓋時，自動剔除面以隱藏面。",
	"menu.texture.edit_externally": "Edit Externally",
	"menu.mirror_painting.texture": "2D Editor Symmetry",
	"menu.mirror_painting.texture.desc": "Enable mirror painting in 2D space on the image or texture",
	"menu.animator.rotation_global": "Rotate in Global Space",
	"uv_editor.face_properties": "Face Properties",
	"uv_editor.face_properties.material_instance": "Material Instance",
	"uv_editor.tint.info": "Tint can be enabled on a face to tell Minecraft to tint it. In vanilla, tint can only be used by specific blocks such as leaves and redstone dust, and can only have a value of 0.",
	"uv_editor.cullface.info": "啟用剔除面功能後，如果 Minecraft 世界中指定方向上有另一個完整的方塊緊鄰某個方塊放置，則該方塊的某個面將不再渲染。這可以用於優化效能。",
	"uv_editor.material_instance.info": "材質實例可以設定為使用者自訂名稱，此名稱可用於行為包中的方塊 JSON 文件，為面指定特定的紋理和材質。",
	"display.reference.frame_invisible": "物品展示框（隱形）",
	"data.settings_profile": "配置",
	"message.display_skin.invalid_name": "無法找到名稱爲「%0」的Minecraft帳戶。",
	"dialog.load_plugins_from_query.title": "加載插件",
	"dialog.load_plugins_from_query.text": "此鏈接的插件需要被安裝。您確定要安裝此插件嗎？",
	"dialog.select_model.title": "選擇模型",
	"dialog.select_model.bones": "骨骼",
	"dialog.select_model.cubes": "多立方",
	"dialog.settings.create_profile": "創建配置...",
	"settings_profile.confirm_delete": "你確定要刪除這個設定配置？",
	"settings_profile.condition.type.selectable": "手動選擇",
	"settings.interface_mode": "介面模式",
	"settings.interface_mode.desc": "介面模式，重新啟動 Blockbench 以應用更改",
	"settings.interface_mode.auto": "自動",
	"settings.interface_mode.desktop": "桌面應用程式",
	"settings.interface_mode.mobile": "行動裝置應用程式",
	"settings.paint_through_transparency": "透過透明顏料作畫",
	"settings.paint_through_transparency.desc": "啟用「鎖定 Alpha 通道」後，可透過透明像素進行繪製。",
	"action.tab_overview": "標簽頁總覽",
	"action.tab_overview.desc": "查看所有打開的標簽頁並跳轉至其中一個",
	"action.slider_color_red": "红色",
	"action.slider_color_green": "綠色",
	"action.slider_color_blue": "藍色",
	"action.add_animation_controller": "加入動作控制器",
	"action.add_animation_controller.desc": "創建動作控制器",
	"action.animation_controller_preview_mode": "預覽",
	"action.animation_controller_preview_mode.paused": "已暫停",
	"action.animation_controller_preview_mode.manual": "手動預覽",
	"action.animation_controller_preview_mode.play": "自動播放",
	"action.keyframe_interpolation.bezier": "貝塞爾",
	"action.keyframe_bezier_linked": "連接貝塞爾手柄",
	"action.keyframe_bezier_linked.desc": "連接左和右關鍵幀的貝塞爾手柄",
	"action.reset_keyframe_handles": "重置關鍵幀手柄",
	"action.reset_keyframe_handles.desc": "重置已選中關鍵幀的貝塞爾手柄",
	"action.looped_animation_playback": "循環播放",
	"action.looped_animation_playback.desc": "無限循環預覽動畫",
	"timeline.bind_to_actor": "綁定到Actor",
	"animation_controllers.select_preset": "選擇控制器預設...",
	"animation_controllers.state.animations": "動畫",
	"animation_controllers.state.particles": "粒子",
	"animation_controllers.state.sounds": "音效",
	"animation_controllers.state.on_entry": "進入時",
	"animation_controllers.state.on_exit": "退出時",
	"animation_controllers.state.transitions": "過渡動畫",
	"animation_controllers.state.condition": "條件",
	"animation_controllers.state.blend_transition": "混合時間",
	"animation_controllers.state.shortest_path": "按最短的路徑混合",
	"animation_controllers.state.edit_transition": "編輯過渡動畫",
	"menu.color_picker.picker_type": "類型選擇",
	"menu.color_picker.picker_type.square": "方形",
	"menu.color_picker.picker_type.wheel": "色輪",
	"menu.color_picker.slider_mode": "滑桿模式",
	"menu.color_picker.slider_mode.hsv": "色相、飽和度和亮度（HSV）",
	"menu.color_picker.slider_mode.rgb": "RGB",
	"menu.texture.render_mode.additive": "附加",
	"panel.color.picker_options": "取色器設定",
	"panel.animation_controllers": "動畫控制器",
	"display.preset.armor_stand": "地面（盔甲架）",
	"data.file_path": "文件路徑",
	"dialog.extrude.orientation": "坐標系",
	"dialog.extrude.orientation.upright": "直立",
	"dialog.extrude.orientation.flat": "平坦",
	"dialog.scale.box_uv_warning": "縮放 Box UV 模型可能會破壞UV。相反，請嘗試在外部縮放你的模型，或者在《文件 > 項目》 中切換到逐面UV模式。",
	"dialog.create_gif.format": "格式",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG 序列",
	"dialog.create_gif.pixelate": "像素化",
	"dialog.create_gif.bg_image": "背景圖片",
	"dialog.create_gif.turn.desc": "在錄制中旋轉模型。使用負數值順時針旋轉。60相當于每秒旋轉一周。",
	"settings_profile.condition": "狀態",
	"settings_profile.condition.type.file_path.desc": "使用正規表示式語法來符合目前項目的檔案路徑，目錄路徑請使用正斜線。",
	"settings.only_selected_bezier_handles": "僅顯示選定的貝塞爾曲線控制柄",
	"settings.only_selected_bezier_handles.desc": "隱藏目前未選取的貝塞爾關鍵影格的控制柄",
	"settings.embed_textures": "嵌入紋理",
	"settings.embed_textures.desc": "嵌入.bbmodel格式的紋理檔",
	"action.selection_mode.cluster": "組",
	"dialog.copied_to_clipboard": "複制到剪貼板",
	"data.reference_image": "參考圖片",
	"message.delete_reference_image": "您確定要刪除這張參考圖嗎？本操作無法撤銷。",
	"message.add_reference_image.message": "Select where to load the reference image",
	"message.import_particle_texture.import": "Import Particle Texture",
	"message.import_particle_texture.message": "Would you like to import a texture file to be used for your particle?",
	"message.save_codec_selector.title": "Save Model Format",
	"message.save_codec_selector.message": "Select a format to save the model in.",
	"message.save_codec_selector.project_file": "Blockbench Project (.bbmodel)",
	"message.save_codec_selector.both": "兩者",
	"message.display_skin.username": "使用者名稱 (Java)",
	"message.palette_locked": "The palette is locked",
	"dialog.project.default_uv_mode": "默認UV模式",
	"dialog.project.default_uv_mode.description": "此項目的默認UV模式。每個塊都可以更改UV模式。",
	"dialog.export_options.title": "導出選項",
	"dialog.edit_texture.preview": "預覽",
	"dialog.proportional_editing.range": "距離",
	"dialog.proportional_editing.falloff": "衰減方式",
	"dialog.proportional_editing.falloff.linear": "線性",
	"dialog.proportional_editing.falloff.hermite_spline": "平滑",
	"dialog.proportional_editing.falloff.constant": "固定",
	"dialog.proportional_editing.selection": "選擇",
	"dialog.proportional_editing.selection.linear": "線性距離",
	"dialog.proportional_editing.selection.connections": "選擇",
	"dialog.mirror_painting_texture_center.middle": "中間",
	"dialog.mirror_painting_texture_center.custom": "自定義",
	"dialog.settings.reset_to_default": "重置為預設",
	"keybindings.item.num_slider.increase": "增加",
	"keybindings.item.num_slider.decrease": "減少",
	"settings.always_show_splash_art": "Always Show Splash Art",
	"settings.always_show_splash_art.desc": "Always display the splash art on the start screen",
	"action.slider_palette_color": "切換調色板顔色",
	"action.slider_palette_color.desc": "循環切換調色板中顔色",
	"action.proportional_editing": "衰減編輯",
	"action.proportional_editing.desc": "在調整模型部分時同時按比例影響周邊頂點",
	"action.limit_to_palette": "限制為調色板內顔色",
	"action.limit_to_palette.desc": "限制材質中的顔色為現有調色板中顔色",
	"action.edit_reference_images": "編輯參考圖像",
	"action.edit_reference_images.desc": "打開參考圖像模式以添加或編輯參考圖和藍圖",
	"action.add_reference_image": "添加參考圖像",
	"action.reference_image_from_clipboard": "從剪貼板讀取參考圖像",
	"action.reference_image_list": "參考圖像",
	"action.connect_uv_faces": "連接UV面",
	"action.connect_uv_faces.desc": "將選中的UV面連接于上次選中的UV面",
	"action.merge_uv_vertices": "合並UV頂點",
	"action.merge_uv_vertices.desc": "將首先選中的UV頂點對其于最後選中的UV頂點",
	"action.bedrock_animation_mode": "Bedrock版動畫模式",
	"action.bedrock_animation_mode.desc": "選中為Minecraft: Bedrock版編輯動畫的模式",
	"action.bedrock_animation_mode.entity": "實體",
	"action.bedrock_animation_mode.attachable_first": "物品第一人稱",
	"action.bedrock_animation_mode.attachable_third": "物品第三人稱",
	"timeline.amplify": "Amplify",
	"menu.options": "選項",
	"menu.palette.lock_palette": "Lock Palette",
	"menu.uv.export": "Export UV Mapping",
	"menu.uv.flip_x": "Ｘ軸鏡象",
	"menu.uv.flip_y": "Ｙ軸鏡象",
	"menu.mirror_painting.enabled": "啟動",
	"reference_image.position": "位置",
	"reference_image.size": "大小",
	"reference_image.rotation": "選轉",
	"reference_image.opacity": "透明度",
	"reference_image.visibility": "可見度",
	"reference_image.clear_mode": "Clear Mode",
	"reference_image.layer": "Layer",
	"reference_image.layer.background": "Behind Model",
	"reference_image.layer.viewport": "Above Model",
	"reference_image.layer.float": "Above Interface",
	"reference_image.scope": "Scope",
	"reference_image.scope.project": "Just this project",
	"reference_image.scope.global": "All projects",
	"reference_image.enabled_modes": "Enabled in Modes",
	"codec.common.encoding": "編碼",
	"codec.common.armature": "將分組作為骨架導出",
	"codec.common.export_animations": "導出動作",
	"codec.common.embed_textures": "內嵌紋理",
	"preview.center_camera": "Center Camera",
	"display.reference.frame_top": "表面展示框",
	"display.reference.frame_top_invisible": "表面展示框（隱形）",
	"action.proportional_editing_range": "等比例編輯範圍",
	"action.proportional_editing_range.desc": "調整等比例編輯的範圍",
	"action.toggle_all_reference_images": "隱藏/展示全部參考圖",
	"action.toggle_all_reference_images.desc": "同時隱藏/展示全部參考圖",
	"action.add_animation_controller_state": "增加動畫控制狀態",
	"action.add_animation_controller_state.desc": "為動畫控制增加新狀態",
	"menu.slider.round_value": "Round Value",
	"texture.error.too_large": "Resolution exceeds the maximum of %0",
	"dialog.copy_to_clipboard": "複制到剪切板中",
	"dialog.open_url": "打開 URL 鏈接",
	"reference_image.image": "圖片",
	"uv_editor.rotate_uv": "選轉UV",
	"generic.error": "錯誤",
	"projects.start_screen": "Start Screen",
	"message.invalid_link.message": "The shared model \"%0\" that you are trying to load is either invalid or has expired.",
	"message.plugin_dependencies.title": "插件依賴",
	"message.plugin_dependencies.message1": "該插件需要以下依賴項：",
	"message.plugin_dependencies.message1_update": "插件 %0 已更新，現在需要以下依賴項：",
	"message.plugin_dependencies.message2": "您是否希望下載它們使其繼續?",
	"message.plugin_dependencies.invalid": "很抱歉，該插件無法安裝，它存在無效的依賴項：",
	"message.preview_scene_load_failed": "Failed to load preview scene. Check your internet connection.",
	"dialog.convert_project.text1": "將項目轉化為另一格式。",
	"dialog.convert_project.text2": "請謹慎轉化。不同格式有著不同功能及限制，某些轉化將破壞部分項目。",
	"dialog.convert_project.text3": "你無法撤銷轉化，因此默認情況下將會複制一份副本。",
	"dialog.unsaved_work.title": "為儲存做品",
	"dialog.unsaved_work.text": "以下項目有未保存的變更。是否保存更改？",
	"dialog.unsaved_work.discard_all": "全都丟棄",
	"dialog.unsaved_work.save_all": "儲存全部",
	"dialog.resize_texture.mode": "模式",
	"dialog.resize_texture.mode.crop": "裁切/擴展",
	"dialog.resize_texture.mode.scale": "縮放",
	"dialog.plugins.is_installed": "已下載",
	"dialog.plugins.is_disabled": "已禁用",
	"dialog.plugins.disable": "禁用",
	"dialog.plugins.enable": "啓用",
	"dialog.plugins.dependencies": "依賴在：",
	"dialog.view_backups.open_folder": "打開資料夾",
	"dialog.share_model.reference_images": "包括參考圖像",
	"dialog.share_model.too_large": "上傳失敗：模型過大",
	"dialog.share_model.too_large_references": "上傳失敗：模型過大。請取消參考圖像並再次嘗試。",
	"settings.stretch_linked": "Link Stretching",
	"settings.stretch_linked.desc": "Stretch the cube in all directions with the same value",
	"settings.grids": "Show Grids",
	"settings.grids.desc": "Show or hide all 3D grids",
	"settings.double_click_switch_tools": "Switch Tools on Double Click",
	"settings.double_click_switch_tools.desc": "Double click the viewport to switch between tools",
	"settings.outlines_in_paint_mode": "Selection Outlines in Paint Mode",
	"settings.outlines_in_paint_mode.desc": "Display element selection outlines while in paint mode",
	"settings.json_indentation": "JSON Indentation",
	"settings.json_indentation.desc": "Indentation style for exported JSON files",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Spaces: 4",
	"settings.json_indentation.spaces_2": "Spaces: 2",
	"action.slider_stretch": "拉伸",
	"action.slider_stretch.desc": "將立方體沿軸成倍拉伸而不改變其UV",
	"action.view_backups": "查看備份",
	"action.view_backups.desc": "浏覽自動保存的項目備份列表",
	"action.search_outliner": "搜索大綱",
	"action.search_outliner.desc": "在大綱中以關鍵詞檢索元素名稱",
	"action.mirror_modeling": "建模鏡射",
	"action.mirror_modeling.desc": "在X軸上啓用鏡像編輯模式。你在視口中做的一切更改都會折射到另一邊，除非元素有上特殊禁用。",
	"action.allow_element_mirror_modeling": "啓用鏡像編輯模式",
	"action.allow_element_mirror_modeling.desc": "選擇所選元素是否受鏡像編輯模式影響",
	"action.switch_face_crease": "切換面折疊",
	"action.switch_face_crease.desc": "切換面的對折方向",
	"action.clear_unused_texture_space": "清除紋理未使用的部分",
	"action.clear_unused_texture_space.desc": "將紋理中沒有對應元素UV映射的部分清除",
	"action.split_screen": "分屏",
	"action.split_screen.desc": "选择视口分屏模式",
	"action.split_screen.single": "單一",
	"action.split_screen.double_horizontal": "水平雙屏",
	"action.split_screen.double_vertical": "垂直雙屏",
	"action.split_screen.quad": "四屏",
	"action.split_screen.triple_left": "三連左屏",
	"action.split_screen.triple_right": "三連右屏",
	"action.split_screen.triple_top": "三連上屏",
	"action.split_screen.triple_bottom": "三連下屏",
	"action.uv_project_from_view": "自視角投射UV",
	"action.uv_project_from_view.desc": "以3D視圖的視角為所選的面自動生成UV",
	"action.graph_editor_other_graphs": "顯示其他圖表",
	"action.graph_editor_other_graphs.desc": "決定未選中的軸的圖表是否被展示",
	"action.graph_editor_include_other_graphs": "包含其他軸",
	"action.graph_editor_include_other_graphs.desc": "決定圖標編輯器是否包括視圖中未選中的圖表",
	"action.set_ik_source": "設定IK根",
	"action.set_ik_source.desc": "設定這個空對象能夠以反向運動學移動的鏈的根",
	"edit.loop_cut.cuts": "切",
	"panel.element.stretch": "Stretch",
	"preview_scene.minecraft_plains": "草甸",
	"preview_scene.minecraft_cherry_grove": "櫻花樹叢",
	"preview_scene.minecraft_snowy_tundra": "雪原",
	"preview_scene.minecraft_sunset": "日出",
	"preview_scene.minecraft_night": "夜晚",
	"preview_scene.minecraft_desert": "沙漠",
	"preview_scene.minecraft_underwater": "水下",
	"preview_scene.minecraft_coral_reef": "珊瑚礁",
	"preview_scene.minecraft_lush_cave": "蒼鬱洞窟",
	"preview_scene.minecraft_deep_dark": "深暗之域",
	"generic.navigate_forward": "Forward",
	"generic.navigate_back": "Back",
	"action.element_render_order": "透明度渲染順序",
	"action.element_render_order.default": "自動",
	"action.element_render_order.behind": "背後",
	"action.element_render_order.in_front": "前面",
	"message.installing_update.title": "Update Available",
	"message.installing_update.message": "A new version is ready to be installed. After closing the app, please allow for around %0 seconds before opening Blockbench again or turning off the computer, for the update to be installed.",
	"settings.brush_cursor_2d": "2D Brush Cursor",
	"settings.brush_cursor_2d.desc": "Display an outline around the brush in the 2D workspace",
	"settings.brush_cursor_3d": "3D Brush Cursor",
	"settings.brush_cursor_3d.desc": "Display an outline around the brush in the 3D workspace",
	"settings.cdn_mirror": "Use CDN Mirror",
	"settings.cdn_mirror.desc": "Use the mirror CDN to download plugins. The mirror receives updates faster and works in some regions where the default does not work.",
	"data.layer": "圖層",
	"data.panel": "面板",
	"generic.confirm_delete": "您確定要刪除這個嗎?",
	"format_category.general": "總體",
	"modifier_actions.no_uniform_scaling": "Free Scaling",
	"message.texture_refresh_conflict.title": "Conflicting Texture Versions",
	"message.texture_refresh_conflict.message": "The texture file might contain changes that conflict with Blockbench's version",
	"message.texture_refresh_conflict.keep_ours": "Keep Blockbench's version",
	"message.texture_refresh_conflict.keep_theirs": "Load file and discard all changes and layers in Blockbench",
	"message.group_required_to_animate": "You cannot animate this type of element. Create a group or armature to animate it.",
	"dialog.texture.uv_size": "UV尺寸",
	"dialog.advanced_screenshot.angle_preset": "預設角度",
	"dialog.advanced_screenshot.resolution": "分辨率",
	"dialog.advanced_screenshot.zoom_to_fit": "縮放以適配",
	"dialog.advanced_screenshot.zoom": "縮放/焦距",
	"dialog.advanced_screenshot.anti_aliasing": "抗鋸齒",
	"dialog.advanced_screenshot.anti_aliasing.off": "關閉",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "多取樣",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "超取樣",
	"dialog.advanced_screenshot.show_gizmos": "顯示編輯裝置",
	"dialog.advanced_screenshot.shading": "陰影",
	"settings.auto_keyframe": "Auto Keyframe",
	"settings.auto_keyframe.desc": "Automatically create a keyframe with default values at the timeline start when transforming the bone at a later point",
	"settings.modded_entity_integer_size": "Modded Entity Integer Size",
	"settings.modded_entity_integer_size.desc": "Limit cube sizes in the Modded Entity format to integers. While floats are technically supported in some versions, integers are much easier to UV-map.",
	"category.layers": "圖層",
	"keybind.paint_secondary_color": "Paint with Secondary Color",
	"action.selection_tool_operation_mode": "選擇模式",
	"action.selection_tool_operation_mode.create": "新的選擇",
	"action.selection_tool_operation_mode.add": "加展選中",
	"action.selection_tool_operation_mode.subtract": "減展選中",
	"action.selection_tool_operation_mode.intersect": "相交",
	"action.pixel_perfect_drawing": "完美像素繪制模式",
	"action.pixel_perfect_drawing.desc": "不在轉彎處産生雙像素而精准繪制出像素",
	"action.selection_tool": "選區工具",
	"action.selection_tool.desc": "選取部分圖像",
	"action.selection_tool.rectangle": "長方形",
	"action.selection_tool.ellipse": "椭圆",
	"action.selection_tool.lasso": "套索選擇",
	"action.selection_tool.wand": "魔棒工具",
	"action.selection_tool.color": "同種顔色",
	"action.move_layer_tool": "移動圖層",
	"action.move_layer_tool.desc": "移動當前圖層或選區",
	"action.export_modded_animations": "導出模組實體動畫",
	"action.export_modded_animations.desc": "為 Java 版模組實體模型導出動畫",
	"action.swap_colors": "切換顔色",
	"action.swap_colors.desc": "在主要和次要顔色之間切換",
	"action.apply_mesh_rotation": "應用旋轉",
	"action.apply_mesh_rotation.desc": "重置網格的元素旋轉，並將其應用于幾何",
	"action.flip_texture_x.desc": "水平翻轉紋理或圖層",
	"action.flip_texture_y.desc": "垂直翻轉紋理或圖層",
	"action.rotate_texture_cw.desc": "將紋理或圖層順時針旋轉",
	"action.rotate_texture_ccw.desc": "將紋理或圖層逆時針旋轉",
	"action.crop_texture_to_selection": "將紋理裁剪至選區內",
	"action.create_empty_layer": "創造空白圖層",
	"action.enable_texture_layers": "启用图层",
	"action.disable_texture_layers": "禁用圖層",
	"action.layer_opacity": "圖層透明度",
	"action.layer_to_texture_size": "放大圖層至紋理尺寸",
	"action.layer_to_texture_size.desc": "放大紋理至圖層尺寸",
	"action.merge_layer_down": "向下合並",
	"action.merge_layer_down.desc": "向下合並入圖層",
	"action.advanced_screenshot": "高級截屏...",
	"action.advanced_screenshot.desc": "使用高級選項對模型截屏",
	"action.bake_ik_animation": "烘焙反向運動",
	"action.bake_ik_animation.desc": "將反向運動提供的旋轉烘培入所選的動畫內",
	"action.save_animation_preset": "保存動畫預設...",
	"action.save_animation_preset.desc": "將所選的關鍵幀保存為動畫預設",
	"action.animation_onion_skin": "動畫洋蔥皮",
	"action.animation_onion_skin.desc": "展示動畫其他幀的線框作為參考",
	"action.apply_animation_preset": "應用動畫映射",
	"action.apply_animation_preset.desc": "選擇動畫映射並應用于所選骨骼",
	"menu.brush_presets.pixel_perfect": "Pixel-perfect Brush",
	"panel.layers": "Layers",
	"uv_editor.copy_paste_tool.to_layer": "To New Layer",
	"format.image.new": "Create New Image",
	"format.image.info.summary": "The 2D Image editor lets you create and edit images and pixel art directly in Blockbench, without the need for an external image editor. Edit images, modify textures, or create your own pixel art!",
	"settings.move_with_selection_tool": "Use Selection Tool to Move Selections",
	"settings.move_with_selection_tool.desc": "Allow the Selection Tool to directly move selections, without having to switch to the Move Layer tool",
	"settings.final_newline": "Final Newline",
	"settings.final_newline.desc": "在匯出的文件末尾插入換行符",
	"action.crop_layer_to_selection": "將圖層裁切至選區內",
	"action.edit_mode_uv_overlay.desc": "在編輯模式中將UV映射覆蓋進行展示",
	"menu.image": "圖片",
	"menu.texture.discard_changes": "Discard Changes",
	"menu.texture.discard_changes.desc": "Discard all unsaved changes and load the latest version from the file",
	"panel.textures.images": "圖片",
	"dialog.advanced": "高級",
	"dialog.recommended_option": "推薦用",
	"modifier_actions.snap_to_center": "Snap to Center",
	"modifier_actions.snap_to_pixels": "Snap to Pixels",
	"message.invalid_format.install_plugin": "Install plugin '%0'",
	"message.plugin_deprecated.message": "Are you sure you want to install this deprecated plugin?",
	"message.plugin_deprecated.install_anyway": "Install Anyway",
	"message.image_editor.not_found": "Could not find the selected image editor. Please select a different option.",
	"message.knife_tool.confirm": "Press %0 or click here to apply Knife Tool",
	"message.knife_tool.skipped_face": "Cannot cut between different faces. Include the edges or vertices between them!",
	"message.optimize_animation.keyframes_removed": "Removed %0 redundant keyframes",
	"message.optimize_animation.nothing_to_optimize": "Found nothing to optimize!",
	"message.duplicate_bone_copy_animation.title": " 拷貝動畫",
	"message.duplicate_bone_copy_animation.message": "The duplicated bone is animated in %0 animations. Do you want to copy the keyframes over to the new bone?",
	"message.auto_fix_mesh_edit.title": "自動修復",
	"message.auto_fix_mesh_edit.revert": "Revert Edit",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Certain vertices have been moved into the same spot. How would you like to proceed?",
	"message.auto_fix_mesh_edit.concave_quads": "一個或多個四邊形面現在呈現凹面，這可能會導致 UV 貼圖和渲染出現問題， Blockbench 可以自動為您修復此問題：",
	"message.auto_fix_mesh_edit.merge_vertices": "Merge Vertices",
	"message.auto_fix_mesh_edit.split_quads": "Split Quads",
	"message.load_images.add_image": "增加圖片",
	"dialog.project.modded_entity_entity_class": "實體層級",
	"dialog.resize_texture.offset": "偏離",
	"dialog.animated_texture_editor.code_reference": "代碼參考",
	"dialog.animated_texture_editor.code_reference.about": "用于執行紋理動畫的代碼是作為參考被生成，而在編輯前有可能無法工作。請參考以下文檔以了解更多。",
	"dialog.animated_texture_editor.code_reference.docs": "文檔",
	"dialog.animated_texture_editor.reframe": "重幀",
	"dialog.animated_texture_editor.stride": "幀尺寸",
	"dialog.animated_texture_editor.frames": "幀數量",
	"dialog.animated_texture_editor.add_frame": "增加幀",
	"dialog.animated_texture_editor.resize_frames": "重設幀尺寸...",
	"dialog.animated_texture_editor.apply": "應用",
	"dialog.add_primitive.edge_size": "邊緣大小",
	"dialog.change_animation_speed.speed": "速度",
	"dialog.change_animation_speed.adjust_snapping": "調整吸附",
	"dialog.optimize_animation.selection": "選擇",
	"dialog.optimize_animation.selection.selected_keyframes": "所選關鍵幀",
	"dialog.optimize_animation.selection.selected_animation": "所選動畫",
	"dialog.optimize_animation.selection.all_animations": "全部動畫",
	"dialog.optimize_animation.thresholds": "阈值大小",
	"dialog.import_obj.obj": "OBJ檔案",
	"dialog.import_obj.mtl": "MTL檔案",
	"dialog.import_obj.scale": "縮放",
	"layout.thumbnail": "Custom Thumbnail CSS",
	"settings.pixel_grid": "Pixel Grid",
	"settings.pixel_grid.desc": "Show texture pixel grid on elements in edit mode",
	"settings.image_editor_grid_size": "Image Editor Grid Size",
	"settings.image_editor_grid_size.desc": "Size of the large grid in the 2D image editor",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export selected texture",
	"settings.optifine_save_default_texture.desc": "Export the selected texture as the default texture of the model",
	"action.slider_color_select_threshold": "色彩選擇阈值",
	"action.slider_color_select_threshold.desc": "相鄰像素的顔色要多相似以被顔色工具或魔棒工具選中",
	"action.stretch_tool": "拉伸",
	"action.stretch_tool.desc": "用于拉伸元素的工具",
	"action.knife_tool": "刀具工具",
	"action.knife_tool.desc": "用于將網格面切割為更小形狀的工具",
	"action.duplicate_project": "複制項目",
	"action.duplicate_project.desc": "創建當前項目的副本",
	"action.transform_space.parent": "父級",
	"action.transform_pivot_space": "驅軸變換空間",
	"action.solidify_mesh_selection": "固化面",
	"action.solidify_mesh_selection.desc": "使網格上所選的面固化",
	"action.animated_texture_editor": "手翻書動畫...",
	"action.animated_texture_editor.desc": "設定或編輯所選紋理的手翻書動畫",
	"action.center_individual_pivots": "居中獨立驅軸",
	"action.center_individual_pivots.desc": "將所選元素的驅軸分別居中",
	"action.uv_cycle": "循環 UV",
	"action.uv_cycle.desc": "順序循環 UV 頂點而不改變 UV 位置",
	"action.uv_cycle_invert": "循環翻轉 UV",
	"action.uv_cycle_invert.desc": "反向循環 UV 頂點而不改變 UV 位置",
	"action.slider_animation_controller_speed": "控制回放速度",
	"action.slider_animation_controller_speed.desc": "動畫控制器的播放速度百分比",
	"action.optimize_animation": "優化動畫",
	"action.optimize_animation.desc": "優化當前動畫並減少關鍵幀數量",
	"action.change_animation_speed": "更改動畫速度...",
	"action.change_animation_speed.desc": "改變所選動畫的速度",
	"timeline.select_particle_file": "Select Particle File",
	"timeline.select_sound_file": "Select Sound File",
	"menu.cube.texture.default": "預設",
	"menu.texture.particle.clear": "Stop using for Particles",
	"menu.texture.use_as_default": "設定成預設",
	"menu.texture.use_as_default.clear": "Unassign as Default",
	"menu.toolbar.overflow": "Toolbar Overflow",
	"edit.solidify_mesh_selection.thickness": "粗細度",
	"reference_image.sync_to_timeline": "Sync To Timeline",
	"reference_image.toggle_playback": "Play/Pause",
	"dialog.add_primitive.shape.beveled_cuboid": "使立方體改為斜面",
	"dialog.ignore_all": "忽略所有",
	"data.texture_group": "紋理組",
	"data.animation": "動畫",
	"generic.on": "On",
	"generic.off": "Off",
	"format.free.info.3d_printing": "3D 打印",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"dialog.expand_texture_selection.radius": "數量",
	"dialog.expand_texture_selection.corner": "邊角形狀",
	"dialog.expand_texture_selection.corner.round": "圓形",
	"dialog.expand_texture_selection.corner.square": "方形",
	"dialog.expand_texture_selection.corner.manhattan": "曼哈頓",
	"dialog.merge_animation.merge_target": "合並到",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",
	"settings.recovery_save_interval": "Recovery Point Save Interval",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",
	"settings.save_view_per_tab": "Save View per Tab",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"keybind.preview_select.multi_select": "Multi-select",
	"keybind.preview_select.group_select": "Group-select",
	"keybind.preview_select.loop_select": "Loop-select",
	"action.fill_mode.selection": "選擇",
	"action.fill_mode.selected_elements": "選中的元素",
	"action.image_tiled_view": "平鋪視圖",
	"action.image_tiled_view.description": "在 2D 編輯器中啓用平鋪視圖",
	"action.image_onion_skin_view": "洋蔥皮圖像編輯器",
	"action.image_onion_skin_view.description": "在 2D 編輯器中啓用洋蔥皮視圖",
	"action.expand_texture_selection": "擴大紋理選擇",
	"action.expand_texture_selection.desc": "擴大或縮小紋理選擇",
	"action.switch_tabs.reverse_order": "逆序",
	"action.save_project_incremental": "增量保存項目",
	"action.save_project_incremental.desc": "將當前模型以項目文件的形式增量保存（比如：project_2.bbmodel）",
	"action.copy.multiple": "全部複制",
	"action.copy.multiple.desc": "逐一複制所有可用數據",
	"action.paste.multiple": "全部粘貼",
	"action.randomize_marker_colors": "隨機化顔色標記",
	"action.cube_light_emission": "發光",
	"action.cube_light_emission.desc": "更改所選方塊的發光強度，值介于 0 到 15 之間",
	"action.view_mode.colored_solid": "有顔色標記的實體",
	"action.focus_on_selection.rotate_only": "只旋轉",
	"action.create_texture_group": "創建紋理組",
	"action.create_texture_group.desc": "為你的紋理們創建一個分組",
	"action.uv_maximize.all_faces": "應用到所有面",
	"action.retarget_animators": "重新定位動畫",
	"action.retarget_animators.desc": "選擇一個動畫以及其對應的骨骼或元素",
	"action.merge_animation": "合並動畫",
	"action.merge_animation.desc": "將動畫合並到另一個動畫中",
	"action.add_keyframe.reset_values": "使用默認值",
	"action.set_timeline_range_start": "設置時間線範圍開始",
	"action.set_timeline_range_start.desc": "在動畫時間軸中設置自定義播放範圍的起點",
	"action.set_timeline_range_end": "設置時間線範圍結束",
	"action.set_timeline_range_end.desc": "在動畫時間軸中設置自定義播放範圍的終點",
	"action.disable_timeline_range": "禁用時間線範圍",
	"action.disable_timeline_range.desc": "在動畫時間軸中禁用自定義播放範圍",
	"menu.texture_group.resolve": "Resolve",
	"menu.image_tiled_view.mirrored": "Mirrored Edges",
	"menu.image_onion_skin_view.frame": "Frames",
	"menu.image_onion_skin_view.frame.last_viewed": "Last Viewed Frame",
	"menu.image_onion_skin_view.frame.previous": "Previous Frame",
	"menu.image_onion_skin_view.frame.next": "Next Frame",
	"menu.image_onion_skin_view.frame.both": "Previous + Next",
	"menu.image_onion_skin_view.display": "Display",
	"menu.image_onion_skin_view.display.pixels": "Smaller Pixels",
	"menu.image_onion_skin_view.display.transparent": "Transparent",
	"menu.image_onion_skin_view.above": "Display Above",
	"menu.animation.reload": "Reload",
	"switches.autouv.alt": "Relative",
	"display.rotation_pivot": "旋轉樞軸",
	"display.scale_pivot": "縮放樞軸",
	"display.reference.fox": "狐狸",
	"display.reference.eating": "吃東西",
	"preview_scene.sky": "天空",
	"preview_scene.space": "太空",
	"preview_scene.minecraft_ocean": "海洋",
	"message.import_palette.selection_only": "Selection only",
	"dialog.blend_transition_edit.ease_in_out": "漸進漸出（%0）",
	"dialog.blend_transition_edit.generate": "生成...",
	"dialog.blend_transition_edit.generate.learn_more": "預覽和更多信息",
	"dialog.blend_transition_edit.generate.curve": "緩動類型",
	"dialog.blend_transition_edit.generate.steps": "關鍵幀",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "限制 Blockbench 每秒渲染的幀數。實際幀速率受限於設備顯示能力。",
	"settings.outliner_reveal_on_select": "Reveal Elements on Select",
	"settings.outliner_reveal_on_select.desc": "Reveal elements in the ouliner when selected",
	"settings.java_export_pivots": "Export Pivots in Java block/item models",
	"settings.java_export_pivots.desc": "Save pivot points in Java block/item models on cubes without rotation",
	"animation_controllers.state.blend_transition_curve": "混合過渡曲線",
	"menu.slider.reset_vector": "Reset Vector",
	"dialog.blend_transition_edit.extended": "擴展圖表",
	"message.screenshot_too_large.title": "Screenshot Resolution Issue",
	"message.screenshot_too_large.message": "螢幕擷取畫面渲染失敗，請嘗試降低解析度或停用超採樣後重試。",
	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "Controls",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "用於在標準螢幕上顯示高動態範圍的 PBR 渲染近似方法。",
	"settings.audio_scrubbing": "Timeline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "Rotate",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "Material Preview",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "Direction",
	"edit.extrude_mesh_selection.direction.outwards": "Outwards",
	"edit.extrude_mesh_selection.direction.average": "Average",
	"edit.extrude_mesh_selection.even_extend": "偶數延伸",
	"edit.vertex_snap.align": "Align",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 Axis",
	"edit.vertex_snap.ignore_axis": "Ignore Axis",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"panel.collections": "Collections",
	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"action.focus_on_selection.zoom": "Zoom to fit",
	"display.reference.tooting": "Horn Tooting",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "Mesh",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGBA Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGBA channel",
	"dialog.project.java_block_version": "Format Version",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "亮化",
	"action.blend_mode.darken": "暗化",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Mesh",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "此樣條曲線應該渲染哪個幾何體？",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Set Vertex Weights",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Calculate Vertex Weights",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Vertex Weight",
	"action.view_mode.weighted_bone_colors": "Vertex Bone Colors",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "延伸",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",
	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Connected",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Weight",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",
	"action.element_render_order.short": "渲染順序",
	"action.element_render_order.desc": "元素渲染順序，這有助於修復被透明紋理元素遮蔽的元素，對於不透明元素，請將其設為「自動」。",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "輕重筆刷混合模式",
	"action.weight_brush_blend_mode.set": "設",
	"action.weight_brush_blend_mode.add": "添",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot",
	"data.generated_item_mesh": "Generated Item Model",
	"message.generated_item_model.title": "Generated Item Model",
	"message.generated_item_model.message": "This model has no elements of its own. Minecraft builds the item shape from the model's texture, so what you see here is only a preview of that shape. It cannot be edited, and is not exported.\n\nTo change how the item looks in game, edit the texture.",
	"message.generated_item_model.edit_texture": "Edit Texture",
	"message.generated_item_model.convert": "Convert to Editable Model",
	"message.convert_generated_item_model.title": "Convert to Editable Model",
	"message.convert_generated_item_model.message": "This builds real elements by extruding the texture, so you can change the item shape in 3D.\n\nIf you only want to change how the item looks, you do not need this. Edit the texture instead, and Minecraft will keep generating the shape from it.",
	"message.convert_generated_item_model.confirm": "Extrude Texture",
	"message.generated_item_model_conflict.title": "Generated Item Model",
	"message.generated_item_model_conflict.message": "Minecraft cannot use both a generated item model and elements. Now that this model has elements, the generated shape is ignored in game.",
	"message.generated_item_model_conflict.convert": "Convert the Generated Model to Cubes",
	"message.generated_item_model_conflict.convert.desc": "Extrude the texture into real elements, so nothing is lost",
	"message.generated_item_model_conflict.remove": "Remove the Generated Model",
	"message.generated_item_model_conflict.remove.desc": "Delete the preview and model the item from scratch",
	"message.generated_item_model_conflict.keep": "Keep It as a Reference",
	"message.generated_item_model_conflict.keep.desc": "Show it in Blockbench only, never exported",
	"message.add_reference_image.globally": "Add for all projects",
	"dialog.extrude.orientation.upright_z": "Upright Z",
	"dialog.extrude.depth": "Depth",
	"dialog.add_primitive.shape.icosphere": "Icosphere",
	"dialog.add_primitive.shape.octahedron": "Octahedron",
	"dialog.add_primitive.shape.dodecahedron": "Dodecahedron",
	"dialog.add_primitive.detail": "Detail",
	"dialog.plugins.update": "Update",
	"dialog.plugins.update_available": "Update Available",
	"dialog.create_variable_placeholder.variable": "Variable",
	"dialog.create_variable_placeholder.type": "Type",
	"dialog.create_variable_placeholder.type.value": "Value",
	"dialog.create_variable_placeholder.type.slider": "Slider",
	"dialog.create_variable_placeholder.type.toggle": "Toggle",
	"dialog.create_variable_placeholder.type.impulse": "Impulse",
	"dialog.create_variable_placeholder.value": "Value",
	"dialog.create_variable_placeholder.duration": "Duration",
	"dialog.create_variable_placeholder.step": "Step",
	"dialog.create_variable_placeholder.range": "Range",
	"dialog.create_variable_placeholder.output": "Output",
	"dialog.view_built_in_variables.function": "Parameters required",
	"dialog.advanced_screenshot.export": "Export",
	"dialog.preview_options.show_element_markers": "Show Element Markers",
	"dialog.preview_options.show_element_markers.desc": "Display markers to indicate the position for elements such as bones, null objects, and locators",
	"settings.maximum_zoom_distance": "Maximum Zoom Distance",
	"settings.maximum_zoom_distance.desc": "How far the camera can be zoomed away from the model",
	"settings.constant_outlines": "Constant Outlines",
	"settings.constant_outlines.desc": "Always display element outlines regardless of selection",
	"settings.new_project_dialog": "New Project Dialog",
	"settings.new_project_dialog.desc": "Show the Project dialog when creating a new project",
	"settings.opacity_range": "Opacity Range",
	"settings.opacity_range.desc": "Select which range is used to control opacity of layers and brushes",
	"settings.automatic_plugin_updates": "Automatic Plugin Updates",
	"settings.automatic_plugin_updates.desc": "Automatically update plugins to keep them up-to-date",
	"settings.native_window_frame": "Native Window Frame",
	"settings.native_window_frame.desc": "Use a native window frame in the style of the OS",
	"keybind.preview_scroll_pan": "Scroll Pan View",
	"keybind.preview_scroll_pan.desc": "Use scroll to pan the view, can be used for two-finger panning with trackpads",
	"action.position_slider_per_element": "Move Individual Positions",
	"action.position_slider_per_element.desc": "When enabled, using the position sliders changes individual positions per element. When disabled, the whole selection moves in the selected transform space.",
	"action.origin_slider_direct_values": "Move Pivot Values Directly",
	"action.origin_slider_direct_values.desc": "When enabled, pivot sliders will move the pivot point directly, affecting the position of the object. When disabled, positions get adjusted automatically.",
	"action.brush_lock_mode": "Brush Lock Mode",
	"action.brush_lock_mode.none": "Unlocked",
	"action.brush_lock_mode.element": "Lock to Element",
	"action.brush_lock_mode.face": "Lock to Face",
	"action.slider_brush_aspect_ratio": "Brush Aspect Ratio",
	"action.slider_brush_aspect_ratio.desc": "Aspect ratio of the brush",
	"action.screen_space_brush_projection": "Screen Space Brush Projection",
	"action.screen_space_brush_projection.desc": "Use screen space projection for painting with a brush",
	"action.close_other_projects": "Close Other Tabs",
	"action.close_other_projects.desc": "Closes all projects except the open project",
	"action.close_projects_to_right": "Close Tabs to the Right",
	"action.close_projects_to_right.desc": "Closes all project tabs to the right of the open project",
	"action.extrude_texture_to_model": "Extrude Texture",
	"action.extrude_texture_to_model.desc": "Generate a model by extruding this texture",
	"action.experimental_settings": "Experimental Settings",
	"action.experimental_settings.desc": "Customize experimental developer settings",
	"action.convert_texture_mesh_to_cubes": "Convert to Extruded Model",
	"action.convert_texture_mesh_to_cubes.desc": "Replace the texture mesh with cubes extruded from its texture, in the same place",
	"action.flip_in_place": "Flip in Place %0",
	"action.flip_in_place.desc": "Flip the selected elements on the %0 axis in its current position",
	"action.create_layer_group": "Create Layer Group",
	"action.resolve_layer_group": "Resolve Layer Group",
	"action.preview_models": "Preview Models",
	"action.preview_models.desc": "Select and edit reference models",
	"action.keyframe_select_before_playhead": "Select Keyframes Before Playhead",
	"action.keyframe_select_before_playhead.desc": "Select all keyframes in the timeline at or before the playhead",
	"action.keyframe_select_after_playhead": "Select Keyframes After Playhead",
	"action.keyframe_select_after_playhead.desc": "Select all keyframes in the timeline at or after the playhead",
	"action.set_ik_pole": "Set IK Pole",
	"action.set_ik_pole.desc": "Select the pole that the chain will attempt to face towards while moving",
	"action.create_variable_placeholder": "Create Variable Placeholder",
	"action.create_variable_placeholder.desc": "Add a variable to the variable placeholders list to preview a value",
	"action.view_built_in_variables": "View Built-in Variables",
	"action.view_built_in_variables.desc": "Display the list of variables and their values that Blockbench automatically provides for animation preview",
	"menu.paint": "Paint",
	"menu.brush_presets.screen_space": "Screen Space Brush",
	"edit.loop_cut.spacing": "Spacing",
	"edit.loop_cut.spacing.proportional": "Proportional",
	"edit.loop_cut.spacing.even_start": "Even - From Start",
	"edit.loop_cut.spacing.even_end": "Even - From End",
	"cube.shade_direction_override": "Shade Direction Override",
	"cube.shade_direction_override.desc": "Shade every face of the cube as if it was facing this direction. If not set, each face is shaded based on the direction it actually faces. This does not affect ambient occlusion or shading based on light level.",
	"null_object.ik_target": "IK Target",
	"null_object.ik_source": "IK Root",
	"null_object.ik_pole": "IK Pole",
	"reference_image.layer.scene": "3D Scene",
	"reference_image.view_mode": "View Mode",
	"reference_image.view_mode.flat_image": "Flat Image",
	"reference_image.cull_backface": "Hide Backside",
	"codec.common.merge_armature_mesh": "Merge Armature Mesh",
	"preview_model.transform": "Transform",
	"preview_model.reset_transform": "Reset Transform",
	"preview_model.minecraft_player": "Minecraft Player",
	"dialog.generate_pbr_map.channel": "PBR Channel",
	"dialog.generate_pbr_map.channel.metalness": "Metalness",
	"dialog.generate_pbr_map.channel.emissive": "Emissive",
	"dialog.generate_pbr_map.channel.roughness": "Roughness",
	"dialog.generate_pbr_map.method": "Source",
	"dialog.generate_pbr_map.method.value": "Value",
	"dialog.generate_pbr_map.method.brightness": "Brightness",
	"dialog.generate_pbr_map.method.saturation": "Saturation",
	"dialog.generate_pbr_map.method.hue": "Hue",
	"dialog.generate_pbr_map.method.red": "Red",
	"dialog.generate_pbr_map.method.green": "Green",
	"dialog.generate_pbr_map.method.blue": "Blue",
	"dialog.generate_pbr_map.method.empty": "Empty",
	"dialog.generate_pbr_map.in_range": "Input Range",
	"dialog.generate_pbr_map.out_range": "Output Range",
	"dialog.generate_pbr_map.invert": "Invert",
	"dialog.generate_pbr_map.preset": "Preset",
	"dialog.generate_pbr_map.preset.apply_preset": "Apply Preset",
	"dialog.generate_pbr_map.update_values": "Update with current values",
	"dialog.generate_pbr_map.preset.new_preset": "New Preset...",
	"action.image_editor_checkerboard": "Checkerboard",
	"action.image_editor_checkerboard.desc": "Toggle the checkerboard background of the 2D Editor",
	"message.child_model_only.resolve": "Resolve Parent Models",
	"message.child_model_only.resolve.desc": "Merge the whole parent chain into this model",
	"message.child_model_only.open.desc": "Open the parent in a new tab, keeping it separate from this model",
	"action.brush_lock_mode.selected_faces": "Lock to Selected Faces",
	"reference_image.view_mode.plane": "3D Plane",
	"preview_model.minecraft_crafting_table": "Minecraft Crafting Table",
	"dialog.extrude.animated": "Animated Texture",
	"dialog.scale.box_uv_warning_required": "Scaling cubes that use Box UV may break the UV mapping. Instead, try to scale your model during implementation, or use Inflate.",
	"menu.color_picker.picker_type.wheel_static": "Wheel (Static)"
}